<template>
  <div>
    <template v-if="!getAcessoModulo({ user: user, modulo: CALCULAR_RACAO })">
      <v-container>
        <v-layout wrap>
          <h2>{{ strings[idioma].funcionalidade_exclusiva_premium }}</h2>
          <Premium />
        </v-layout>
      </v-container>
    </template>
    <template v-else>
      <v-stepper v-model="step" non-linear>
        <template
          v-if="
            alimentoAberto && ![null, undefined].includes(alimentoAberto.id)
          "
        >
          <p
            style="
              position: fixed;
              background-color: indigo;
              color: #fff;
              top: -5px;
              left: 20%;
              right: 20%;
              z-index: 100;
              padding: 10px;
            "
          >
            {{ strings[idioma].voce_esta_editando }} :
            {{
              alimentoAberto.nome
                ? "#" + alimentoAberto.id + " -" + alimentoAberto.nome
                : ""
            }}
          </p>
        </template>
        <v-stepper-header>
          <v-stepper-step
            :complete="stepComplete[0]"
            :editable="true"
            edit-icon="$vuetify.icons.complete"
            step="1"
          >
            <b>{{ strings[idioma].selecao_alimentos }}</b>
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            :editable="stepComplete[0]"
            edit-icon="$vuetify.icons.complete"
            step="2"
          >
            <b>{{ strings[idioma].composicoes_alimento }}</b>
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items style="margin-top: 3px">
          <v-stepper-content :style="heightOverflow" step="1">
            <v-card class="mb-3">
              <v-sheet class="pa-3 green">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      :disabled="loadingAlimentos"
                      v-model="search_"
                      :label="strings[idioma].pesquisar"
                      dark
                      flat
                      solo-inverted
                      hide-details
                      clearable
                      append-icon="mdi-magnify"
                      clear-icon="mdi-close"
                      @keyup.enter="search = search_"
                    />
                  </v-flex>
                </v-layout>
              </v-sheet>
              <v-card-text class="card-tree">
                <v-layout
                  v-if="fontesMineraisSelecionada"
                  justify-start
                  class="grey lighten-5"
                  row
                  wrap
                />
                <v-layout
                  v-if="
                    loadingAlimentos ||
                    !categorias_alimentos ||
                    !categorias_alimentos.filter
                  "
                  align-center
                  justify-center
                  column
                >
                  <h5 v-if="loadingAlimentos">
                    {{ strings[idioma].carregando_alimentos }}
                  </h5>
                  <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                  />
                </v-layout>
                <v-layout v-else row wrap>
                  <v-flex pb-2>
                    <v-treeview
                      ref="dTreeAlimentos"
                      :style="heightTree"
                      :items="categorias_alimentos.filter((c) => !c.oculto)"
                      :search="search"
                      :filter="filter"
                      :item-text="
                        idioma === 0
                          ? 'name'
                          : idioma === 1
                          ? 'name_en'
                          : 'name_es'
                      "
                      :active.sync="alimentoClick"
                      :open.sync="open"
                      v-model="treeAlimentos"
                      :open-all="expandeArvore"
                      :selectable="selectable"
                      item-children="derivados"
                      class="grey lighten-5"
                      active-class
                      selected-color="primary"
                      activatable
                      lazy
                      transition
                      expand-icon=""
                      on-icon="mdi-checkbox-marked"
                      off-icon="mdi-checkbox-blank-outline"
                      indeterminate-icon="mdi-minus-box"
                      return-object
                    >
                      <template slot="label" slot-scope="{ item }">
                        <span
                          v-if="
                            item.derivados &&
                            !item.oculto &&
                            item.derivados.filter((d) => d.EXCLUIDO !== 1)
                              .length > 0
                          "
                          style="
                            cursor: pointer;
                            font-weight: 600;
                            text-decoration-color: grey;
                          "
                          @click="open = open[0] !== item ? [item] : []"
                        >
                          <v-icon>
                            {{
                              open[0] === item
                                ? "mdi-chevron-down"
                                : "mdi-chevron-right"
                            }}</v-icon
                          >
                          {{
                            idioma === 0
                              ? item.name
                              : idioma === 1
                              ? item.name_en
                              : item.name_es
                          }}
                          <small style="font-weight: 100"
                            >({{
                              Object.values(item.derivados).filter(
                                (d) => d.EXCLUIDO !== 1
                              ).length
                            }}
                            {{ strings[idioma].alimentos }})</small
                          >
                        </span>
                        <template v-else>
                          <span
                            v-show="item.EXCLUIDO === 0"
                            style="cursor: pointer"
                          >
                            <v-icon>
                              {{
                                alimentos_selecionados.includes(item)
                                  ? "mdi-checkbox-marked"
                                  : "mdi-checkbox-blank-outline"
                              }}
                            </v-icon>
                            {{
                              idioma === 0
                                ? item.name
                                : idioma === 1
                                ? item.name_en
                                : item.name_es
                            }}
                            <template
                              v-if="item.cliente && item.cliente !== null"
                            >
                              <b
                                >({{
                                  item.id_cliente === null
                                    ? strings[idioma].base_pessoal
                                    : item.cliente.nome
                                }})</b
                              >
                            </template>
                            <v-icon
                              v-if="item.patrocinado"
                              :title="strings[idioma].recomendado_brcorte"
                              color="primary"
                              >mdi-star</v-icon
                            >
                            <v-icon
                              v-if="item.patrocinado"
                              :title="strings[idioma].recomendado_brcorte"
                              color="primary"
                              @click="
                                info = true;
                                verEmpresa(item);
                              "
                              >mdi-information</v-icon
                            >
                          </span>
                        </template>
                      </template>
                    </v-treeview>
                    <v-layout
                      v-if="fontesMineraisSelecionada"
                      justify-start
                      wrap
                    >
                      <v-flex pb-2>
                        <v-btn
                          block
                          color="primary"
                          @click="checkMineraisComuns"
                          >{{
                            !getSelecionaComunsStatus
                              ? strings[idioma].selecionar_fontes_mais_comuns
                              : strings[idioma].deselecionar_fontes_mais_comuns
                          }}</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-divider v-if="$vuetify.breakpoint.mdAndUp" vertical />
                  <v-flex :style="heightTree" xs12 md4 xl6>
                    <div
                      v-if="
                        alimentos_selecionados.filter(
                          (el) => el.id !== ID_LEITE_VACA
                        ).length === 0
                      "
                      key="title_selecione_alimentos"
                      class="title font-weight-light grey--text pa-3 text-xs-center"
                    >
                      {{ strings[idioma].selecione_alimentos }}
                    </div>
                    <div
                      v-else
                      key="title_alimentos"
                      class="title pa-2 text-xs-center"
                    >
                      {{ strings[idioma].alimentos_selecionados }}
                    </div>
                    <v-scroll-x-transition group hide-on-leave>
                      <v-chip
                        v-for="(
                          alimento, index
                        ) in alimentos_selecionados.filter(
                          (el) => el.id !== ID_LEITE_VACA
                        )"
                        :key="index"
                        color="grey"
                        dark
                        small
                        close
                        @input="removeAlimento(index)"
                      >
                        <div
                          style="
                            max-width: 200px;
                            overflow: auto;
                            overflow-x: hidden;
                          "
                        >
                          {{
                            idioma === 0
                              ? alimento.name
                              : idioma === 1
                              ? alimento.name_en
                              : alimento.name_es
                          }}
                        </div>
                      </v-chip>
                    </v-scroll-x-transition>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-layout v-if="!alimentos_selecionados.length" row>
              <span style="color: #f52b1b; font-weight: 400">
                {{ strings[idioma].minimo_alimento }}
              </span>
            </v-layout>
            <v-layout row wrap justify-end>
              <v-btn
                color="primary"
                @click="alimentos_selecionados.length ? (step = 2) : null"
              >
                {{ strings[idioma].botao_seguinte }}
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-layout>
            <Banner />
          </v-stepper-content>
          <v-stepper-content :style="heightOverflow" step="2">
            <v-layout
              v-if="exportando_dados"
              align-center
              justify-center
              column
            >
              <v-progress-circular :size="50" color="primary" indeterminate />
            </v-layout>
            <div v-else>
              <v-card
                v-if="parseInt(step) === 2 && !dialogNutrientes"
                class="mb-3"
              >
                <v-card-title>
                  <v-layout row justify-end>
                    <v-flex xs2>
                      <v-text-field
                        v-model="quantidade_produzida"
                        :label="strings[idioma].quantidade_produzida"
                        placeholder="50000"
                        inputmode="decimal"
                        class="text-field-table"
                        suffix="kg"
                        type="number"
                        style="margin-right: 20px"
                      />
                    </v-flex>
                    <v-btn
                      color="success"
                      :disabled="calcPerc('raw') !== 100"
                      @click="criarSuplemento()"
                    >
                      <v-icon>mdi-content-save</v-icon>
                      {{ strings[idioma].salvar_alimento }}
                    </v-btn>
                    <div>
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        bottom
                        right
                        offset-y
                        transition="slide-y-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn :disabled="calcPerc('raw') !== 100" v-on="on">
                            <v-icon>mdi-arrow-down-bold-circle-outline</v-icon>
                            &nbsp;
                            {{ strings[idioma].exporta }}
                          </v-btn>
                        </template>
                        <v-card>
                          <v-list>
                            <v-list-tile
                              v-for="(item, index) in save_options.filter(
                                (e) => e.pertence === 'CR'
                              )"
                              :key="index"
                              @click="salvar(item.value)"
                            >
                              <v-list-tile-content>
                                <v-list-tile-title>{{
                                  item.title[idioma]
                                }}</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-card>
                      </v-menu>
                    </div>
                    <v-btn color="error" @click="resetAlimentos">
                      <v-icon>mdi-delete</v-icon>
                      &nbsp;
                      {{ strings[idioma].botao_reset }}
                    </v-btn>
                  </v-layout>
                </v-card-title>
                <v-sheet class="pa-3 green">
                  <v-layout row wrap>
                    <v-flex xs9>
                      <v-text-field
                        v-model="searchRestricao"
                        :label="strings[idioma].pesquisar"
                        dark
                        flat
                        solo-inverted
                        hide-details
                        clearable
                        clear-icon="mdi-close"
                      />
                    </v-flex>
                    <v-divider horizontal />
                    <v-flex
                      v-if="!verificaPecuarista()"
                      xs12
                      md3
                      style="
                        padding: 0px 10px 0px 10px;
                        padding-right: -5px;
                        margin-top: -5px;
                      "
                      @click="!acesso_premium ? sejaPremium() : null"
                    >
                      <v-radio-group
                        v-model="tipoEntrada"
                        v-bind="binding"
                        :style="
                          $vuetify.breakpoint.width >= 1000
                            ? 'background-color: #fff; padding: 5px; margin-left: 20px; border-radius: 10px;'
                            : 'padding: 5px; margin-left: 20px; border-radius: 10px;'
                        "
                        :dark="!$vuetify.breakpoint.width >= 1000"
                        :disabled="!acesso_premium"
                        class="flex-center"
                        center
                        flat
                        small
                        row
                        solo-inverted
                        hide-details
                        clearable
                      >
                        <v-radio
                          v-for="option in [
                            { id: '/%MN', nome: strings[idioma]['/%MN'] },
                            { id: '/kgMN', nome: strings[idioma]['/MN'] },
                          ]"
                          :key="option.id"
                          :label="option.nome"
                          :value="option.id"
                          :selected="option[0]"
                        />
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-sheet>
                <v-data-table
                  v-if="parseInt(step) === 2 && !dialogNutrientes"
                  :items="alimentos_selecionados"
                  :pagination.sync="pagination"
                  :search="searchRestricao"
                  :custom-filter="filterTable"
                  :headers="[
                    {
                      text: 'alimento',
                      value: 'name',
                    },
                  ]"
                  :no-results-text="strings[idioma].sem_resultado"
                  hide-actions
                  hide-headers
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td style="padding: 0px">
                      <v-layout
                        align-center
                        justify-space-around
                        row
                        wrap
                        style="width: 100%"
                      >
                        <v-flex>
                          <v-layout
                            :justify-center="$vuetify.breakpoint.xs"
                            row
                          >
                            <v-btn
                              :small="$vuetify.breakpoint.xs"
                              :color="
                                !props.item.alterado &&
                                !props.item.id_alimento_pai
                                  ? undefined
                                  : 'warning'
                              "
                              :disabled="
                                edicaoBloqueada ||
                                props.item.restrito ||
                                props.item.id === ID_LEITE_VACA
                              "
                              :title="
                                props.item.id === ID_LEITE_VACA
                                  ? strings[idioma].edicao_leite_vaca
                                  : null
                              "
                              flat
                              @click="
                                indexAlimentoDialog =
                                  alimentos_selecionados.findIndex(
                                    (el) => el.id === props.item.id
                                  );
                                dialogNutrientes = true;
                              "
                            >
                              <v-icon left dark>mdi-pencil</v-icon>
                              <v-layout row>
                                {{
                                  idioma === 0
                                    ? !props.item.alterado
                                      ? props.item.name
                                      : props.item.name + " *"
                                    : idioma === 1
                                    ? !props.item.alterado
                                      ? props.item.name_en
                                      : props.item.name_en + " *"
                                    : !props.item.alterado
                                    ? props.item.name_es
                                    : props.item.name_es + " *"
                                }}
                              </v-layout>
                            </v-btn>
                          </v-layout>
                        </v-flex>

                        <v-flex xs3 lg6>
                          <v-layout justify-space-around row pb-2 pt-2>
                            <div></div>
                            <v-layout align-center justify-center column>
                              <v-text-field
                                v-model.lazy="props.item.custo"
                                pattern="\d*"
                                inputmode="decimal"
                                class="text-field-table"
                                outline
                                browser-autocomplete
                                @keypress="
                                  (val) => onlyFloat(val, props.item, 'custo')
                                "
                                @paste="
                                  (evt) =>
                                    $validateOnlyNumbers(evt, true, idioma)
                                "
                              />
                              <div
                                :class="
                                  $vuetify.breakpoint.xs ? 'small-text' : ''
                                "
                              >
                                {{ strings[idioma].custo_total }}
                              </div>
                            </v-layout>
                            <v-layout align-center justify-center column>
                              <v-text-field
                                v-model.lazy="props.item.quantidade"
                                pattern="\d*"
                                inputmode="decimal"
                                class="text-field-table"
                                outline
                                browser-autocomplete
                                @keypress="
                                  (val) =>
                                    onlyFloat(val, props.item, 'quantidade')
                                "
                                @paste="
                                  (evt) =>
                                    $validateOnlyNumbers(evt, true, idioma)
                                "
                              />
                              <div
                                v-if="tipoEntrada === '/%MN'"
                                :class="
                                  $vuetify.breakpoint.xs ? 'small-text' : ''
                                "
                              >
                                {{ strings[idioma].quantidade + " (%MN)" }}
                              </div>
                              <div
                                v-else
                                :class="
                                  $vuetify.breakpoint.xs ? 'small-text' : ''
                                "
                              >
                                {{ strings[idioma].quantidade + " (kg MN)" }}
                              </div>
                            </v-layout>
                          </v-layout>
                        </v-flex>
                        <v-flex xs10 lg1>
                          <v-layout align-center justify-center column>
                            <v-btn
                              v-if="props.item.id !== ID_LEITE_VACA"
                              :small="$vuetify.breakpoint.xs"
                              :disabled="edicaoBloqueada"
                              style="max-width: 10px"
                              flat
                              @click="
                                indexAlimentoDialog = treeAlimentos.findIndex(
                                  (el) => el.id === props.item.id
                                );
                                removeAlimento(indexAlimentoDialog);
                              "
                            >
                              <v-icon left dark>mdi-close</v-icon>
                            </v-btn>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </td>

                    <!-- <v-layout
                      v-if="!($vuetify.breakpoint.xs || $vuetify.breakpoint.sm)"
                      style="width: 600px; z-index: 9999; padding: 0px; position:relative; background: #fff;"
					  class="noprint"
                      >
                      <table v-if="!props.item.restrito" style="position: absolute; overflow: auto;">
                        <tr>
                          <td
                            
                            v-for="val, ing in ingredientesComAditivos"
                            :key="ing + '_nut_' + props.item.id">
                            <v-text-field
                              
                              v-model="props.item.nutrientes[val.id]"
                              pattern="\d*"
                              inputmode="decimal"
                              class="text-field-table"
                              outline
                              browser-autocomplete
                              style="min-width: 100px"
                              :disabled="(props.item.empresa && props.item.empresa !== null)"
							  :value="props.item.nutrientes[val.id]? props.item.nutrientes[val.id] : '0.00'"
                              
							  @change="v => changeIngrediente(val.id, v, val.unidade, props.item)"/>
                            <v-text-field
                              v-if="false"
                              pattern="\d*"
                              inputmode="decimal"
                              class="text-field-table"
                              outline
                              browser-autocomplete
                              style="min-width: 100px"
							  :value="props.item.nutrientes[val.id]? props.item.nutrientes[val.id] : '0.00'"
                              :disabled="(props.item.empresa && props.item.empresa !== null)"
                              @change="v => { props.item.nutrientes[val.id] = v }"
                              @keypress="v => onlyFloat(v, props.item.nutrientes, val.id, 1)"
                              @paste="(evt) => $validateOnlyNumbers(evt, true, 1)"/>
                            <div :class="$vuetify.breakpoint.xs ? 'small-text' : ''">{{ (val.codigo ? val.codigo : val.exigencia) + '(' + (idioma === 0 ? val.unidade : idioma === 1 ? val.unidade_en : val.unidade_es) + ')' }}</div>
                          </td>
                        </tr>
                      </table>
                    </v-layout> -->
                  </template>
                </v-data-table>
              </v-card>
              <div
                v-if="pagination.totalItems > pagination.rowsPerPage"
                class="text-xs-center"
              >
                <v-pagination
                  v-model="pagination.page"
                  :length="
                    Math.ceil(pagination.totalItems / pagination.rowsPerPage)
                  "
                  :total-visible="
                    Math.ceil(pagination.totalItems / pagination.rowsPerPage) <
                    pagination.rowsPerPage + 2
                      ? Math.ceil(
                          pagination.totalItems / pagination.rowsPerPage
                        )
                      : pagination.rowsPerPage + 2
                  "
                  circle
                />
              </div>
              <v-card class="mb-3" v-if="false">
                <v-sheet class="pa-3 indigo">
                  <v-layout justify-end row wrap>
                    <v-flex xs12 lg5>
                      <v-text-field
                        :disabled="loadingAlimentos"
                        v-model.lazy="pbObjetivo"
                        :label="'%PB (Objetivo)'"
                        dark
                        flat
                        solo-inverted
                        hide-details
                        clearable
                        pattern="\d*"
                        inputmode="decimal"
                        @keypress="(val) => onlyFloat(val, 'pbObjetivo')"
                        @paste="
                          (evt) => $validateOnlyNumbers(evt, true, idioma)
                        "
                      />
                    </v-flex>
                    <v-flex xs12 lg2 class="text-xs-center">
                      <v-btn
                        :disabled="
                          pbObjetivo === null || pbObjetivo.trim() === ''
                        "
                        color="success"
                        solo-inverted
                        hide-details
                        clearable
                        @click="calcular"
                      >
                        {{ strings[idioma].calcular }}
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 lg5>
                      <v-text-field
                        disabled
                        :value="
                          'MN:' + calcPerc() + '% | PB: ' + calcPB() + '%'
                        "
                        flat
                        hide-details
                        clearable
                        style="
                          color: #fff;
                          font-weight: bold;
                          background-color: #fff;
                          border-radius: 10px;
                          padding: 5px;
                        "
                      />
                    </v-flex>
                  </v-layout>
                </v-sheet>
              </v-card>
            </div>
            <template v-if="calcPerc('raw') === 100">
              <v-container
                v-if="tipoEntrada === '/%MN'"
                style="background: #e1e1e1"
              >
                <v-layout wrap>
                  <v-flex xs10>
                    <b>{{ strings[idioma].custo }} (1 kg/MN):</b>
                  </v-flex>
                  <v-flex v-if="$route.query.alid" xs2>
                    {{ strings[idioma].moeda_abrev }}
                    {{
                      alimentos_selecionados
                        .filter((a) => a.custo && a.quantidade)
                        .map(
                          (a) =>
                            (parseFloat(a.custo.replace(",", ".")) *
                              parseFloat(a.quantidade.replace(",", "."))) /
                            100
                        )
                        .reduce((a, b) => a + b, 0)
                        .toFixed(2)
                    }}
                  </v-flex>
                  <v-flex v-else xs2>
                    {{ strings[idioma].moeda_abrev }}
                    {{
                      alimentos_selecionados
                        .filter((a) => a.custo && a.quantidade)
                        .map(
                          (a) =>
                            parseFloat(a.custo.replace(",", ".")) *
                            (parseFloat(a.quantidade.replace(",", ".")) / 100)
                        )
                        .reduce((a, b) => a + b, 0)
                        .toFixed(2)
                    }}
                  </v-flex>
                  <v-flex xs12>
                    <hr />
                  </v-flex>
                  <v-flex xs10>
                    <b>{{ strings[idioma].volumoso }}:</b>
                  </v-flex>

                  <v-flex v-if="$route.query.alid" xs2>
                    {{
                      alimentos_selecionados
                        .filter((a) => a.volumoso && a.quantidade)
                        .map(
                          (a) =>
                            (parseFloat(a.quantidade.replace(",", ".")) *
                              parseFloat(a.nutrientes.MS)) /
                            MSTotalAlimentos
                        )
                        .reduce((a, b) => a + b, 0)
                        .toFixed(0)
                    }}
                    %
                  </v-flex>
                  <v-flex v-else xs2>
                    {{
                      alimentos_selecionados
                        .filter((a) => a.volumoso && a.quantidade)
                        .map(
                          (a) =>
                            (parseFloat(a.quantidade.replace(",", ".")) *
                              parseFloat(a.nutrientes.MS)) /
                            MSTotalAlimentos
                        )
                        .reduce((a, b) => a + b, 0)
                        .toFixed(0)
                    }}
                    %
                  </v-flex>
                  <v-flex xs12>
                    <hr />
                  </v-flex>
                  <v-flex xs10>
                    <b>{{ strings[idioma].concentrado }}:</b>
                  </v-flex>
                  <v-flex v-if="$route.query.alid" xs2>
                    {{
                      alimentos_selecionados
                        .filter((a) => !a.volumoso && a.quantidade)
                        .map(
                          (a) =>
                            (parseFloat(a.quantidade.replace(",", ".")) *
                              parseFloat(a.nutrientes.MS)) /
                            MSTotalAlimentos
                        )
                        .reduce((a, b) => a + b, 0)
                        .toFixed(0)
                    }}
                    %
                  </v-flex>
                  <v-flex v-else xs2>
                    {{
                      alimentos_selecionados
                        .filter((a) => !a.volumoso && a.quantidade)
                        .map(
                          (a) =>
                            (parseFloat(a.quantidade.replace(",", ".")) *
                              parseFloat(a.nutrientes.MS)) /
                            MSTotalAlimentos
                        )
                        .reduce((a, b) => a + b, 0)
                        .toFixed(0)
                    }}
                    %
                  </v-flex>
                  <v-flex xs12>
                    <hr />
                  </v-flex>
                </v-layout>
              </v-container>
              <v-container v-else style="background: #e1e1e1">
                <v-layout wrap>
                  <v-flex xs10>
                    <b>{{ strings[idioma].custo }} (1 kg/MN):</b>
                  </v-flex>
                  <v-flex v-if="$route.query.alid" xs2>
                    {{ strings[idioma].moeda_abrev }}
                    {{
                      alimentos_selecionados
                        .filter((a) => a.custo && a.quantidade)
                        .map(
                          (a) =>
                            parseFloat(a.custo.replace(",", ".")) *
                            (parseFloat(a.quantidade.replace(",", ".")) /
                              quantidade_produzida)
                        )
                        .reduce((a, b) => a + b, 0) /
                      quantidade_produzida.toFixed(3)
                    }}
                  </v-flex>
                  <v-flex v-else xs2>
                    {{ strings[idioma].moeda_abrev }}
                    {{
                      alimentos_selecionados
                        .filter((a) => a.custo && a.quantidade)
                        .map(
                          (a) =>
                            parseFloat(a.custo.replace(",", ".")) *
                            (parseFloat(a.quantidade.replace(",", ".")) /
                              quantidade_produzida)
                        )
                        .reduce((a, b) => a + b, 0)
                        .toFixed(2)
                    }}
                  </v-flex>
                  <v-flex xs12>
                    <hr />
                  </v-flex>
                  <v-flex v-if="tipoEntrada === '/%MN'" style="width: 100%">
                    <div style="display: flex">
                      <v-flex xs10>
                        <b>{{ strings[idioma].volumoso }}</b>
                      </v-flex>

                      <v-flex v-if="$route.query.alid" xs2>
                        {{
                          alimentos_selecionados
                            .filter((a) => a.volumoso && a.quantidade)
                            .map(
                              (a) =>
                                (parseFloat(a.quantidade.replace(",", ".")) *
                                  parseFloat(a.nutrientes.MS)) /
                                MSTotalAlimentos
                            )
                            .reduce((a, b) => a + b, 0)
                        }}
                        %
                      </v-flex>
                      <v-flex v-else>
                        {{
                          alimentos_selecionados
                            .filter((a) => a.volumoso && a.quantidade)
                            .map(
                              (a) =>
                                (parseFloat(a.quantidade.replace(",", ".")) *
                                  parseFloat(a.nutrientes.MS)) /
                                MSTotalAlimentos
                            )
                            .reduce((a, b) => a + b, 0)
                            .toFixed(2)
                        }}
                        %
                      </v-flex>
                    </div>
                    <v-flex xs12>
                      <hr />
                    </v-flex>
                    <div style="display: flex">
                      <v-flex xs10>
                        <b>{{ strings[idioma].concentrado }}:</b>
                      </v-flex>
                      <v-flex v-if="$route.query.alid" xs2>
                        {{
                          alimentos_selecionados
                            .filter((a) => !a.volumoso && a.quantidade)
                            .map(
                              (a) =>
                                (parseFloat(a.quantidade.replace(",", ".")) *
                                  parseFloat(a.nutrientes.MS)) /
                                MSTotalAlimentos
                            )
                            .reduce((a, b) => a + b, 0)
                        }}
                        %
                      </v-flex>
                      <v-flex v-else xs2>
                        {{
                          alimentos_selecionados
                            .filter((a) => a.volumoso && a.quantidade)
                            .map(
                              (a) =>
                                (parseFloat(a.quantidade.replace(",", ".")) *
                                  parseFloat(a.nutrientes.MS)) /
                                MSTotalAlimentos
                            )
                            .reduce((a, b) => a + b, 0)
                            .toFixed(2)
                        }}
                        %
                      </v-flex>
                    </div>
                    <v-flex xs12>
                      <hr />
                    </v-flex>
                  </v-flex>
                  <v-flex v-else style="width: 100%">
                    <div style="display: flex">
                      <v-flex xs10>
                        <b>{{ strings[idioma].volumoso }}:</b>
                      </v-flex>

                      <v-flex v-if="$route.query.alid" xs2>
                        {{
                          alimentos_selecionados
                            .filter((a) => a.volumoso && a.quantidade)
                            .map((a) => {
                              let val = 0;

                              val =
                                ((parseFloat(a.quantidade.replace(",", ".")) /
                                  quantidade_produzida) *
                                  parseFloat(a.nutrientes.MS)) /
                                MSTotalAlimentos;

                              return val >= 0 ? val * 100 : 0;
                            })
                            .reduce((a, b) => a + b, 0)
                            .toFixed(0)
                        }}
                        %
                      </v-flex>
                      <v-flex v-else>
                        {{
                          alimentos_selecionados
                            .filter((a) => a.volumoso && a.quantidade)
                            .map((a) => {
                              let val = 0;

                              val =
                                ((parseFloat(a.quantidade.replace(",", ".")) /
                                  quantidade_produzida) *
                                  parseFloat(a.nutrientes.MS)) /
                                MSTotalAlimentos;

                              return val >= 0 ? val * 100 : 0;
                            })
                            .reduce((a, b) => a + b, 0)
                            .toFixed(0)
                        }}
                        %
                      </v-flex>
                    </div>
                    <v-flex xs12>
                      <hr />
                    </v-flex>
                    <div style="display: flex">
                      <v-flex xs10>
                        <b>{{ strings[idioma].concentrado }}:</b>
                      </v-flex>
                      <v-flex v-if="$route.query.alid" xs2>
                        {{
                          alimentos_selecionados
                            .filter((a) => !a.volumoso && a.quantidade)
                            .map((a) => {
                              let val = 0;

                              val =
                                ((parseFloat(a.quantidade.replace(",", ".")) /
                                  quantidade_produzida) *
                                  parseFloat(a.nutrientes.MS)) /
                                MSTotalAlimentos;

                              return val >= 0 ? val * 100 : 0;
                            })
                            .reduce((a, b) => a + b, 0)
                            .toFixed(0)
                        }}
                        %
                      </v-flex>
                      <v-flex v-else xs2>
                        {{
                          alimentos_selecionados
                            .filter((a) => !a.volumoso && a.quantidade)
                            .map((a) => {
                              let val = 0;

                              val =
                                ((parseFloat(a.quantidade.replace(",", ".")) /
                                  quantidade_produzida) *
                                  parseFloat(a.nutrientes.MS)) /
                                MSTotalAlimentos;

                              return val >= 0 ? val * 100 : 0;
                            })
                            .reduce((a, b) => a + b, 0)
                            .toFixed(0)
                        }}

                        %
                      </v-flex>
                    </div>
                    <v-flex xs12>
                      <hr />
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-flex xs12>
                <v-layout row justify-center>
                  <div class="title pb-4 pt-4 text-xs-center">
                    {{ strings[idioma].nutrientes_mistura }}
                  </div>
                </v-layout>
              </v-flex>
              <v-container style="background: #e1e1e1">
                <v-layout
                  v-if="tipoEntrada === '/%MN'"
                  wrap
                  justify-space-between
                >
                  <template v-for="(ing, index) in ingredientesComAditivos">
                    <v-layout
                      v-if="
                        alimentos_selecionados
                          .map((a) => {
                            let val =
                              (parseString(a.quantidade) / 100) *
                              (parseString(a.nutrientes[ing['id']]) / 100);
                            return (val >= 0 ? val : 0) * 100;
                          })
                          .reduce((a, b) => a + b, 0)
                          .toFixed(2) > '0.00'
                      "
                      class="pa-3"
                      flex
                      xs12
                      wrap
                      justify-space-between
                      :key="index"
                    >
                      <v-flex bold xs6>
                        <span class="title pa-2 text-xs-center">
                          {{
                            ing[
                              idioma === 0
                                ? "exigencia"
                                : idioma === 1
                                ? "exigencia_en"
                                : "exigencia_es"
                            ]
                          }}
                        </span>
                      </v-flex>
                      <v-flex v-if="$route.query.alid" xs2>
                        {{
                          alimentos_selecionados
                            .filter((a) => a.quantidade)
                            .map((a) => {
                              let val =
                                ((parseFloat(a.quantidade.replace(",", ".")) *
                                  parseString(a.nutrientes["MS"])) /
                                  MSTotalAlimentos) *
                                parseString(a.nutrientes[ing["id"]]);

                              if (ing["id"] === "MS") {
                                val =
                                  parseFloat(a.quantidade.replace(",", ".")) *
                                  parseString(a.nutrientes["MS"]);
                              }
                              return (val >= 0 ? val : 0) / 100;
                            })
                            .reduce((a, b) => a + b, 0)
                            .toFixed(2)
                        }}
                        <sub>{{ ing["unidade"] }}</sub>
                      </v-flex>
                      <v-flex v-else xs2>
                        {{
                          alimentos_selecionados
                            .filter((a) => a.quantidade)
                            .map((a) => {
                              let nutrient;

                              if (ing["id"].startsWith("AD|")) {
                                nutrient = parseFloat(
                                  String(a.nutrientes[ing["id"]]).replace(
                                    ",",
                                    "."
                                  )
                                );
                              } else {
                                nutrient = parseString(a.nutrientes[ing["id"]]);
                              }

                              let val =
                                ((parseFloat(a.quantidade.replace(",", ".")) *
                                  parseString(a.nutrientes["MS"])) /
                                  MSTotalAlimentos) *
                                nutrient;

                              if (ing["id"] === "MS") {
                                val =
                                  parseFloat(a.quantidade.replace(",", ".")) *
                                  parseString(a.nutrientes["MS"]);
                              }

                              return (val >= 0 ? val : 0) / 100;
                            })
                            .reduce((a, b) => a + b, 0)
                            .toFixed(2)
                        }}
                        <sub>{{ ing["unidade"] }}</sub>
                      </v-flex>
                      <v-flex xs12>
                        <hr />
                      </v-flex>
                    </v-layout>
                  </template>
                </v-layout>
                <v-layout v-else wrap justify-space-between>
                  <template v-for="(ing, index) in ingredientesComAditivos">
                    <v-layout
                      v-if="
                        alimentos_selecionados
                          .map((a) => {
                            let val =
                              (parseString(a.quantidade) /
                                quantidade_produzida) *
                              (parseString(a.nutrientes[ing['id']]) /
                                quantidade_produzida);
                            return (val >= 0 ? val : 0) * quantidade_produzida;
                          })
                          .reduce((a, b) => a + b, 0)
                          .toFixed(2) > '0.00'
                      "
                      class="pa-3"
                      flex
                      xs12
                      wrap
                      justify-space-between
                      :key="index"
                    >
                      <v-flex bold xs6>
                        <span class="title pa-2 text-xs-center">
                          {{
                            ing[
                              idioma === 0
                                ? "exigencia"
                                : idioma === 1
                                ? "exigencia_en"
                                : "exigencia_es"
                            ]
                          }}
                        </span>
                      </v-flex>
                      <v-flex v-if="$route.query.alid" xs2>
                        {{
                          alimentos_selecionados
                            .filter((a) => a.quantidade)
                            .map((a) => {
                              let nutrient;

                              if (ing["id"].startsWith("AD|")) {
                                nutrient = parseFloat(
                                  String(a.nutrientes[ing["id"]]).replace(
                                    ",",
                                    "."
                                  )
                                );
                              } else {
                                nutrient = parseString(a.nutrientes[ing["id"]]);
                              }

                              let val =
                                (((parseFloat(a.quantidade.replace(",", ".")) /
                                  quantidade_produzida) *
                                  parseString(a.nutrientes["MS"])) /
                                  MSTotalAlimentos) *
                                nutrient;

                              if (ing["id"] === "MS") {
                                val =
                                  (parseFloat(a.quantidade.replace(",", ".")) /
                                    quantidade_produzida) *
                                  parseString(a.nutrientes["MS"]);
                              }

                              return val >= 0 ? val : 0;
                            })
                            .reduce((a, b) => a + b, 0)
                            .toFixed(2)
                        }}
                        <sub>{{ ing["unidade"] }}</sub>
                      </v-flex>
                      <v-flex v-else xs2>
                        {{
                          alimentos_selecionados
                            .filter((a) => a.quantidade)
                            .map((a) => {
                              let nutrient;

                              if (ing["id"].startsWith("AD|")) {
                                nutrient = parseFloat(
                                  String(a.nutrientes[ing["id"]]).replace(
                                    ",",
                                    "."
                                  )
                                );
                              } else {
                                nutrient = parseString(a.nutrientes[ing["id"]]);
                              }

                              let val =
                                (((parseFloat(a.quantidade.replace(",", ".")) /
                                  quantidade_produzida) *
                                  parseString(a.nutrientes["MS"])) /
                                  MSTotalAlimentos) *
                                nutrient;

                              if (ing["id"] === "MS") {
                                val =
                                  (parseFloat(a.quantidade.replace(",", ".")) /
                                    quantidade_produzida) *
                                  parseString(a.nutrientes["MS"]);
                              }

                              return val >= 0 ? val : 0;
                            })
                            .reduce((a, b) => a + b, 0)
                            .toFixed(2)
                        }}
                        <sub>{{ ing["unidade"] }}</sub>
                      </v-flex>
                      <v-flex xs12>
                        <hr />
                      </v-flex>
                    </v-layout>
                  </template>
                </v-layout>
              </v-container>
            </template>
            <template v-if="false">
              <v-layout row wrap justify-space-between>
                <v-btn @click="step = 1">
                  <v-icon>mdi-chevron-left</v-icon>
                  {{ strings[idioma].voltar }}
                </v-btn>
                <v-btn
                  :disabled="calcPerc('raw') !== 100"
                  color="success"
                  @click="criarSuplemento()"
                >
                  <v-icon>mdi-content-save</v-icon>
                  {{ strings[idioma].salvar_alimento }}
                </v-btn>
                <v-btn :disabled="calcPerc('raw') !== 100" @click="exporta()">
                  <v-icon />
                  {{ strings[idioma].gerar_pdf }}
                </v-btn>
              </v-layout>
              <v-layout
                :justify-center="$vuetify.breakpoint.xs"
                :justify-space-between="!$vuetify.breakpoint.xs"
                :column="$vuetify.breakpoint.xs"
                align-center
                wrap
              >
                <span
                  v-if="idioma === 0"
                  style="color: #ffa21a; font-weight: 400"
                >
                  Clique na
                  <v-icon>mdi-magnify-plus-outline</v-icon>
                  para ver a composição
                </span>
                <span
                  v-if="idioma === 1"
                  style="color: #ffa21a; font-weight: 400"
                >
                  Click on
                  <v-icon>mdi-magnify-plus-outline</v-icon>
                  to see the composition
                </span>
                <span
                  v-if="idioma === 2"
                  style="color: #ffa21a; font-weight: 400"
                >
                  Haga clic en
                  <v-icon>mdi-magnify-plus-outline</v-icon>
                  para ver la composición
                </span>
              </v-layout>
            </template>
            <v-divider />
            <Banner />
            <v-layout v-if="tab === 2" wrap>
              <v-card flex class="elevation-1" pd-10>
                <v-card-title>
                  <v-layout column wrap align-center justify-space-between>
                    <v-spacer />
                    <v-flex>
                      <span class="headline">{{
                        strings[idioma].comparador_composicoes
                      }}</span>
                    </v-flex>
                  </v-layout>
                </v-card-title>
                <v-layout v-if="step == 2" wrap row>
                  <v-flex
                    v-for="(ingrediente, ing) in ingredientesComAditivos"
                    :key="ing"
                    xs12
                    sm6
                    lg4
                  >
                    <h3
                      v-if="
                        ingredientesComAditivos[ing][
                          idioma === 0
                            ? 'codigo'
                            : idioma === 1
                            ? 'codigo_en'
                            : 'codigo_es'
                        ]
                      "
                    >
                      {{
                        ingredientesComAditivos[ing][
                          idioma === 0
                            ? "codigo"
                            : idioma === 1
                            ? "codigo_en"
                            : "codigo_es"
                        ]
                      }}
                    </h3>
                    <h3 v-else>
                      {{
                        ingrediente[
                          idioma === 0
                            ? "exigencia"
                            : idioma === 1
                            ? "exigencia_en"
                            : "exigencia_es"
                        ]
                      }}
                    </h3>
                    <h4>
                      {{
                        "(" +
                        (idioma === 0
                          ? ingredientesComAditivos[ing].unidade
                          : idioma === 1
                          ? ingredientesComAditivos[ing].unidade_en
                          : ingredientesComAditivos[ing].unidade_es) +
                        ")"
                      }}
                    </h4>
                    <GChart
                      :ref="`gchartAlimentos${ing}`"
                      :data="chartData(ingredientesComAditivos[ing].id)"
                      :options="chartOptions"
                      type="BarChart"
                    />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-layout>
            <v-layout
              v-if="getAcessoModulo({ user: user, modulo: SALVAR_PREDICAO })"
              :justify-center="$vuetify.breakpoint.xs"
              :justify-space-between="!$vuetify.breakpoint.xs"
              :column="$vuetify.breakpoint.xs"
              align-center
              wrap
            >
              <span style="color: #ffa21a; font-weight: 400">
                {{ strings[idioma].alimento_alterado }}
              </span>
            </v-layout>
          </v-stepper-content>
        </v-stepper-items>
        <AlimentosDialog
          :alimentos_selecionados="alimentos_selecionados"
          :ingredientes="ingredientes"
          :dialog-nutrientes="dialogNutrientes"
          :index-alimento-dialog="indexAlimentoDialog"
          @dialogNutrientes="changeDialogNutrientes"
        />
      </v-stepper>
    </template>

    <!-- <AlimentosDialog
      :alimentos_selecionados="alimentos_selecionados"
      :ingredientes="ingredientes"
      :dialog-nutrientes="dialogNutrientes"
      :index-alimento-dialog="indexAlimentoDialog"
      @dialogNutrientes="changeDialogNutrientes"/>
    <template v-if="dieta_salva && dieta_salva.id">
      <CompartilharDialog
        ref="compartilharDialog"
        :dieta_salva="dieta_salva"
        :tipo="'predicao-desempenho'"
        :dieta="dieta_salva.id">
        <div @mudouPagina.passive="mudou" />
      </CompartilharDialog>
    </template> -->
  </div>
</template>
<style scoped>
.centered-input >>> input {
  text-align: center;
}
</style>
<script>
import { mapState, mapActions } from "vuex";
import { VMoney } from "v-money";
import {
  TIPO_NUMBER,
  TIPO_RADIOBUTTOM,
  TIPO_RESULTADO,
  TIPO_MONEY,
  TIPO_PORCENTAGEM,
  ID_LEITE_VACA,
  CRESCIMENTO_TERMINACAO,
  BEZERRO,
  VACA,
  FEMEA,
  MAX_PESO_MACHO,
  MAX_PESO_FEMEA,
  MAX_PESO_BEZERRO,
  MAX_GMD,
  MACHO,
  MACHO_CASTRADO,
  FONTES_COMUNS,
  CALCULAR_RACAO,
} from "@/utils/types.js";
import { replaceSpecialChars } from "@/utils/vuex";
import { updateData, createMD5, getAlimentos } from "@/utils/utils";
import { solverSuplemento } from "@/utils/simplex";
import {
  EXPORTAR_PDF_COMPLETO,
  CRIAR_SUPLEMENTO,
  SALVAR_DIETA,
  SALVAR_PREDICAO,
} from "../utils/types";
import Banner from "./components/Banner";
import Premium from "./Premium.vue";
import Swal from "sweetalert2";
import AlimentosDialog from "./components/AlimentosDialog.vue";

export default {
  directives: { money: VMoney },
  components: {
    Banner,
    Premium,
    AlimentosDialog,
  },
  data: () => ({
    SALVAR_PREDICAO: SALVAR_PREDICAO,
    tab: null,
    qtdMix: 1,
    alimentoAberto: {},
    pbObjetivo: null,
    CALCULAR_RACAO: CALCULAR_RACAO,
    TIPO_NUMBER: TIPO_NUMBER,
    TIPO_RADIOBUTTOM: TIPO_RADIOBUTTOM,
    TIPO_RESULTADO: TIPO_RESULTADO,
    TIPO_MONEY: TIPO_MONEY,
    TIPO_PORCENTAGEM: TIPO_PORCENTAGEM,
    CRESCIMENTO_TERMINACAO: CRESCIMENTO_TERMINACAO,
    BEZERRO: BEZERRO,
    VACA: VACA,
    FEMEA: FEMEA,
    MACHO: MACHO,
    MACHO_CASTRADO: MACHO_CASTRADO,
    MAX_PESO_MACHO: MAX_PESO_MACHO,
    MAX_PESO_FEMEA: MAX_PESO_FEMEA,
    MAX_PESO_BEZERRO: MAX_PESO_BEZERRO,
    MAX_GMD: MAX_GMD,
    ID_LEITE_VACA: ID_LEITE_VACA,
    alimentoClick: [],
    arrayTable: [
      {
        id: "ok",
      },
    ],
    alterado: false,
    calculandoDieta: false,
    calculandoNutrientes: false,
    changeMinMax: false,
    dialogNutrientes: false,
    dietaOtimizada: false,
    dietaSemiOtima: false,
    editarExigencias: false,
    loadingAlimentos: false,
    loadingStep2: false,
    indexAlimentoDialog: 0,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    open: [],
    pagination: {
      rowsPerPage: 20,
      sortBy: null,
      descending: false,
      page: 1,
      totalItems: 0,
    },
    recalculandoExigencias: false,
    search: null,
    search_: null,
    searchRestricao: null,
    step: 1,
    fixaVC: false,
    stepComplete: [false, false, false, false, false],
    treeAlimentos: [],
    validAnimal: false,
    selected: false,
    indetermined: false,
    volumososSelecionados: [],
    concentradoSelecionados: [],
    selecionaComuns: false,
    expandeArvore: false,
    travaSelectAll: false,
    info: false,
    ingredientesComAditivos: [],
    quantidade_produzida: null,
    tipoEntrada: "/%MN",
    MSTotalAlimentos: 0,
  }),
  computed: {
    ...mapState("app", [
      "animal",
      "strings",
      "idioma",
      "user",
      "empresa",
      "optionsNumber",
      "headersExigencias",
      "exigencias",
      "exigencias_selecionadas",
      "categorias_alimentos",
      "alimentos_selecionados",
      "ingredientes",
      "composicao_racao",
      "composicao_dieta",
      "vc",
      "headersComposicaoRacao",
      "excrecao",
      "headersExigenciasRelatorio",
      "relatorio_financeiro",
      "headersRelatorioFinanceiro",
      "exportando_dados",
      "ingredientesCompletos",
      "tipos",
      "save_options",
      "acesso_premium",
    ]),
    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true;
      else binding.row = false;
      return binding;
    },
    selectable() {
      return false;
    },
    edicaoBloqueada() {
      if (this.bloqueado) return true;
      if (
        !this.dietaCarregada ||
        this.dietaCarregada === null ||
        !this.dietaCarregada.compartilhamento ||
        this.dietaCarregada.compartilhamento === null
      )
        return false;
      if (this.dietaCarregada.compartilhamento.pode_editar !== undefined) {
        return !this.dietaCarregada.compartilhamento.pode_editar;
      } else {
        return false;
      }
    },
    filter() {
      return (item, search, textKey) => {
        // if (search.length < 3) return false
        let result = replaceSpecialChars(item[textKey])
          .toLowerCase()
          .search(new RegExp(replaceSpecialChars(search.toLowerCase()), "i"));
        return result > -1;
      };
    },
    filterTable() {
      return (itens, search, textKey) => {
        textKey =
          this.idioma === 0
            ? "name"
            : this.idioma === 1
            ? "name_en"
            : "name_es";
        return itens.filter(
          (item) =>
            replaceSpecialChars(item[textKey])
              .toLowerCase()
              .search(
                new RegExp(replaceSpecialChars(search.toLowerCase()), "i")
              ) > -1
        );
      };
    },
    heightCard() {
      return String(this.$vuetify.breakpoint.height - 289) + "px";
    },
    heightDialog() {
      return this.$vuetify.breakpoint.xs
        ? String(this.$vuetify.breakpoint.height - 150) + "px"
        : String(this.$vuetify.breakpoint.height - 240) + "px";
    },
    heightOverflow() {
      return (
        "max-height: " +
        String(this.$vuetify.breakpoint.height - 120) +
        "px; overflow: auto;"
      );
    },
    heightTree() {
      return (
        "max-height: " +
        String(this.$vuetify.breakpoint.height - 360) +
        "px; overflow: auto; min-height: 200px;"
      );
    },
    fontesMineraisSelecionada() {
      return this.open.filter((a) => a.id === 8).length > 0;
    },
    getSelecionaComunsStatus() {
      return (
        this.fontesMineraisSelecionada &&
        this.alimentos_selecionados.filter(
          (a) => FONTES_COMUNS.filter((f) => f === a.id).length > 0
        ).length === FONTES_COMUNS.length
      );
    },
    chartOptions() {
      return {
        legend: {
          position: "bottom",
        },
        chart: {
          legend: {
            position: "bottom",
          },
          type: "pie",
        },
        colors: ["indigo", "#e6693e", "#ec8f6e", "#f3b49f", "#f6c7b6"],

        width: "100%",
      };
    },
    chartData() {
      return (ing = "MS") => {
        let dados = [
          [
            this.strings[this.idioma].animal,
            this.strings[this.idioma].quantidade,
          ],
        ];

        let c = 0;
        for (let alimento of this.alimentos_selecionados) {
          if (alimento.restrito) continue;
          dados.push([
            alimento[
              this.idioma === 0
                ? "name"
                : this.idioma === 1
                ? "name_en"
                : "name_es"
            ],
            parseFloat(alimento.nutrientes[ing]),
          ]);
          c++;
          // dados.push([alimento.name, alimento.quantidade])
        }
        return dados;
      };
    },
    pbChartData() {
      let dados = [
        [
          this.strings[this.idioma].animal,
          this.strings[this.idioma].quantidade,
        ],
      ];
      let c = 0;
      for (let alimento of this.alimentos_selecionados) {
        dados.push([alimento.name, parseFloat(alimento.nutrientes.PB)]);
        c++;
        // dados.push([alimento.name, alimento.quantidade])
      }
      return dados;
    },
  },
  watch: {
    loadingAlimentos(val) {
      let loading = val || this.loadingStep2 || this.loadingStep1;
      this.$store.commit("setLoading", loading);
    },
    loadingStep1(val) {
      let loading = val || this.loadingAlimentos || this.loadingStep2;
      this.$store.commit("setLoading", loading);
    },
    loadingStep2(val) {
      let loading = val || this.loadingAlimentos || this.loadingStep1;
      this.$store.commit("setLoading", loading);
    },
    alimentoClick(val) {
      if (this.travaSelectAll) {
        this.travaSelectAll = false;
        return;
      }
      if (this.info && this.info === true) return;
      if (val.length) {
        let index = this.alimentos_selecionados.findIndex(
          (el) => el.id === val[0].id
        );

        if (index !== -1) {
          this.removeAlimento(index);
        } else if (!val[0].EXCLUIDO || val[0].EXCLUIDO !== 1) {
          this.alimentos_selecionados.push(val[0]);
        }
        this.$store.commit(
          "setAlimentosSelecionados",
          this.alimentos_selecionados
        );
        this.treeAlimentos = this.alimentos_selecionados;
        this.alimentoClick = [];
      }
    },
    treeAlimentos(val) {
      if (Math.abs(this.alimentos_selecionados.length - val.length) > 2) {
        this.treeAlimentos = this.alimentos_selecionados;
        return;
      }
      this.$store.commit("setAlimentosSelecionados", val);
      this.pagination.totalItems = this.alimentos_selecionados.length;
      this.stepComplete[0] = val.length !== 0;
    },
    search(val) {
      this.expandeArvore = val !== null && val.trim() !== "";
      this.open = this.expandeArvore ? this.categorias_alimentos : [];
    },
    search_(val) {
      if (val === null || val.trim().length <= 2) {
        this.search = "";
      } else {
        this.search = val;
      }
    },
    open(val) {
      if ((this.search === "" || this.search === null) && val.length > 1) {
        this.open = [val[val.length - 1]];
      }
    },
    step(val) {
      this.$store.state.app.step = val;
    },
    tipoEntrada(val) {
      if (
        this.tipoEntrada === "/kgMN" &&
        (!this.quantidade_produzida > 0 || !this.quantidade_produzida === null)
      )
        this.setQuantidade();
    },
    quantidade_produzida(val) {
      this.$store.state.app.animal.total_racao_a_produzir.valor =
        parseFloat(val);
      this.$store.state.app.animal.total_racao_a_produzir.valor_raw =
        parseFloat(val);
      this.quantidade_produzida = parseFloat(val);
    },
  },
  changeDialogNutrientes(dialogNutrientes) {
    this.dialogNutrientes = dialogNutrientes;
  },
  mounted() {
    document.addEventListener("keydown", (evt) => {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        this.dialogNutrientes = false;
      }
    });
    this.getAditivos();
    this.$store.commit("getDefaultVC");
    this.$store.commit("getDefaultAnimal");
    this.$store.commit("getDefaultExigencias");
    this.$store.commit("getDefaultComposicaoRacao");
    this.$store.commit("getDefaultComposicaoDieta");
    this.$store.dispatch("getDefaultPredicao", { step: this.step });
    this.fixaVC = false;
    this.$store.state.app.step = this.step;
    this.loadAlimentosDieta();
  },
  methods: {
    ...mapActions(["calculaExigencias"]),
    imprimir() {
      window.print();
    },
    verificaPecuarista() {
      if (this.user && this.user.plano !== null && this.user.plano.tipo === 0) {
        return true;
      }
      return false;
    },
    changeDialogNutrientes(dialogNutrientes) {
      this.dialogNutrientes = dialogNutrientes;
    },
    changeIngrediente(ingrediente, nutriente, unidade, index) {
      this.alterado = true;
      this.reseted = false;

      let val = this.parseString(nutriente, this.idioma);

      this.alimentos_selecionados[index].nutrientes[ingrediente] = isNaN(val)
        ? 0
        : this.alimentos_selecionados[index].nutrientes[ingrediente];

      if (unidade === "%") {
        this.alimentos_selecionados[index].nutrientes[ingrediente] =
          this.idioma === 0 || this.idioma === 2
            ? (val > 100 ? 100 : val < 0 || isNaN(val) ? 0 : val).toFixed(2)
            : (val > 100 ? 100 : val < 0 ? 0 : val)
                .toFixed(2)
                .replace(".", ".");
      } else {
        this.alimentos_selecionados[index].nutrientes[ingrediente] =
          this.idioma === 0 || this.idioma === 2
            ? (val < 0 || isNaN(val) ? 0 : val).toFixed(2)
            : (val < 0 || isNaN(val) ? 0 : val).toFixed(2).replace(".", ".");
      }
      return this.alimentos_selecionados[index];
    },

    // changeIngrediente(ingrediente, nutriente, unidade, alimento) {
    //   if (nutriente === null || nutriente === undefined) {
    //     nutriente = 0;
    //   }
    //   if (typeof nutriente === "number") {
    //     nutriente = nutriente.toFixed(2);
    //   }
    //   let val = parseFloat(
    //     nutriente.replace(this.strings[this.idioma].separador_float, ".")
    //   );
    //   console.log({ val, nutriente });
    //   alimento.nutrientes[ingrediente] = isNaN(alimento.nutrientes[ingrediente])
    //     ? 0
    //     : alimento.nutrientes[ingrediente];
    //   alimento.nutrientes[ingrediente] = parseFloat(
    //     isNaN(parseFloat(val)) ? 0 : val
    //   ).toFixed(2);
    //   if (unidade === "%" && val > 100) {
    //     let msg = this.strings[this.idioma].cuidado_valores_maiores_100;
    //     let time = 6000;
    //     this.$store.commit("openErrorAlert", { msg, time });
    //   }

    //   /* if (unidade === '%') {
    // 			alimento.nutrientes[ingrediente] = this.idioma === 0 ? (val > 100 ? 100 : (val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace(',', '').replace('.', ',') : (val > 100 ? 100 : (val < 0) ? 0 : val).toFixed(2).replace('.', ',')
    // 		} else {
    // 			alimento.nutrientes[ingrediente] = this.idioma === 0 ? ((val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace(',', '').replace('.', ',') : ((val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace('.', ',')
    // 		} */
    //   return alimento.nutrientes[ingrediente].replace(",", ".");
    // },
    calcular() {
      let pbObjetivo = this.pbObjetivo.replace(
        this.strings[this.idioma].separador_float,
        "."
      );
      solverSuplemento({ pbObjetivo, alimentos: this.alimentos_selecionados })
        .then((r) => {
          let vars = r.result.vars;
          for (let alimentoID in vars) {
            let alIndex = this.alimentos_selecionados.findIndex(
              (a) => a.id === alimentoID
            );
            if (alIndex === -1) continue;
            this.alimentos_selecionados[alIndex].quantidade = (
              vars[alimentoID] * 100
            )
              .toFixed(4)
              .replace(".", this.strings[this.idioma].separador_float);
          }
        })
        .catch((e) => {
          alert(this.strings[this.idioma].suplemento_invalido);
        });
    },

    salvar(tipo = "pdf") {
      if (this.temDadosFaltantesUser(this.user)) return;
      switch (tipo) {
        case "pdf":
          if (!this.getAcessoModulo({ user: this.user, modulo: SALVAR_DIETA }))
            return this.sejaPremium();
          this.exportaCompleto(tipo);
          break;
        case "campo_pdf":
          if (!this.getAcessoModulo({ user: this.user, modulo: SALVAR_DIETA }))
            return this.sejaPremium();
          this.exportaCompleto(tipo);
          break;
      }
    },
    criarSuplemento() {
      if (this.temDadosFaltantesUser(this.user)) return;
      if (!this.getAcessoModulo({ user: this.user, modulo: CRIAR_SUPLEMENTO }))
        return;
      // eslint-disable-next-line camelcase
      const criar = ({
        nome = "",
        nome_sci = "",
        tipo = null,
        id_tipo = null,
        nutrientes = {},
        user = null,
        id = null,
        atualizar = 0,
      }) => {
        let alimento = {
          nome: nome,
          nome_sci: nome_sci,
          tipo: tipo,
          id_tipo: id_tipo,
          nutrientes: nutrientes,
          user: user,
          id_pessoa: user !== null ? user.id : null,
          id: id,
          atualizar: atualizar,
        };
        nutrientes = {};
        let ingredientesSupl = {};
        for (let alimento of this.alimentos_selecionados) {
          if (alimento.quantidade === null || alimento.quantidade === "")
            continue;
          var alimentoQuantidade = parseFloat(
            alimento.quantidade.replace(
              this.strings[this.idioma].separador_float,
              "."
            )
          );
          if (this.tipoEntrada !== "/%MN") {
            alimentoQuantidade =
              (alimentoQuantidade / this.quantidade_produzida) * 100;
          }
          ingredientesSupl[alimento.id] = alimentoQuantidade;
          if (
            ingredientesSupl[alimento.id] === 0 ||
            isNaN(ingredientesSupl[alimento.id])
          )
            delete ingredientesSupl[alimento.id];
        }
        let alimentosIDs = this.alimentos_selecionados.map((a) => a.id);
        alimento["ingredientes"] = ingredientesSupl;
        alimento["id_dieta"] = null;
        let alimentosSelecionados = Object.values(
          this.alimentos_selecionados
        ).filter((al) => alimentosIDs.includes(al.id));
        this.aditivos.forEach((aditivo) => {
          let item = "AD|" + aditivo.id;
          nutrientes[item] = alimentosSelecionados
            .map((al) => {
              let nut = !isNaN(al.nutrientes[item])
                ? al.nutrientes[item]
                : al.nutrientes[String(item).toUpperCase()];
              if (nut === undefined) {
                nut = 0;
              } else {
                nut = parseFloat(String(nut).replace(",", "."));
              }

              let nutMS = al.nutrientes["MS"];
              let cont =
                nut *
                ((ingredientesSupl[al.id] * nutMS) / this.MSTotalAlimentos);

              return ingredientesSupl[al.id] ? cont / 100 : 0;
            })
            .reduce((a, b) => a + b, 0);
        });
        Object.keys(this.ingredientesCompletos).forEach((item) => {
          nutrientes[item] = parseFloat(
            alimentosSelecionados
              .map((al) => {
                let nut = al.nutrientes[String(item).toUpperCase()];
                let nutMS = al.nutrientes["MS"];
                switch (item) {
                  case "NDT":
                    if (nut === undefined || nut === 0 || nut === "0.00") {
                      nut = al.nutrientes["NDT_BRCORTE2016"];
                    }
                    break;
                }

                if (nut === undefined) {
                  nut = 0;
                }

                let cont =
                  nut *
                  ((ingredientesSupl[al.id] * nutMS) / this.MSTotalAlimentos);
                if (item === "MS") {
                  cont = nut * ingredientesSupl[al.id];
                }
                return ingredientesSupl[al.id] ? cont / 100 : 0;
              })
              .reduce((a, b) => a + b, 0)
              .toFixed(2)
          );

          // if (!this.composicao_dieta[item]) {
          //   nutrientes[item] = this.alimentos_selecionados.map(al => this.composicao_racao.MSConcProp.alimentos[al.id] ? al.nutrientes[item] * (this.composicao_racao.MSConcProp.alimentos[al.id].valor / 100) : 0).reduce((a, b) => a + b)
          //   return
          // }
          /*
	          if (isNaN(nutrientes[item])) {
	            nutrientes[item] = this.composicao_dieta[item].pcms
	            if (nutrientes[item] <= 0) nutrientes[item] = this.parseString(this.composicao_dieta[item].total, this.idioma) / this.parseString(this.composicao_racao['MS'].total, this.idioma)
	          }
	          */
          nutrientes[String(item).toUpperCase()] = nutrientes[item];
          switch (item) {
            case "NDT":
              nutrientes["NDT_BRCORTE2016"] = nutrientes["NDT_OBS"] =
                nutrientes[item];
              break;
          }
        });
        alimento.nutrientes = nutrientes;
        return alimento;
      };
      const salvar = (alimento) => {
        delete alimento.tipo;
        delete alimento.user;
        delete alimento.empresa;
        alimento.nutrientes = JSON.stringify(alimento.nutrientes);
        alimento.id_dieta = 1;
        this.alimentoAberto != {}
          ? (alimento.id_dieta = 1)
          : (alimento.id_dieta = null);
        if (alimento.nome === null || alimento.nome === "") {
          let msg = this.strings[this.idioma].preencha_o_nome_do_suplemento;
          let title = "";
          let time = 6000;
          this.$store.commit("openErrorAlert", { title, msg, time });
          return;
        }
        this.calculandoDieta = true;
        let alimentoParam = {
          alimento: alimento,
          id_dieta: alimento.id_dieta ? alimento.id_dieta : null,
        };
        if (![null, undefined].includes(alimento.id)) {
          alimentoParam = {
            alimento: alimento,
            id: alimento.id,
            id_dieta: alimento.id_dieta,
          };
        }
        return this.axios
          .post("alimentos/saveAlimento", alimentoParam)
          .then((res) => {
            let msg = alimentoParam.alimento.atualizar
              ? this.strings[this.idioma].alimento_atualizado
              : this.strings[this.idioma].cadastrado_em_alimentos_usuario;
            let title = "";
            this.$store.commit("openOKModal", { title, msg });
            this.calculandoDieta = false;
            this.alimentoAberto = { ...res.data };
            return this.alimentoAberto;
          })
          .catch((err) => {
            this.calculandoDieta = false;
            return err;
          });
      };
      const prompt = (callback = null) => {
        let tipos = this.tipos;
        let tiposOptions = tipos.map(
          (tipo) =>
            `<option value=${tipo.id}>${
              this.idioma === 0 ? tipo.nome : tipo.nome_ingles
            }</option>`
        );
        let htmlSwal = `
	          <h5>${
              this.strings[this.idioma].nome_do_suplemento
            }:</h5><input style="border:1px solid #000; padding: 2px;" type="text" id="nome"/><br/>
	          <h5>${
              this.strings[this.idioma].tipo_alimento
            }:</h5><select style="border:1px solid #000; padding: 2px;" type="text" id="tipo">${tiposOptions.join(
          ""
        )}</select>
	        `;
        return Swal.fire({
          title: this.strings[this.idioma].criar_suplemento,
          html: htmlSwal,
          confirmButtonText: this.strings[this.idioma].salvar,
          preConfirm: () => {
            let nomesuplemento = document.getElementById("nome").value;
            let tipoSelecionado = document.getElementById("tipo").value;
            return { nome: nomesuplemento, id_tipo: tipoSelecionado };
          },
        }).then((result) => {
          if (callback !== null) return callback(result);
          else if (result.isConfirmed && result.value !== null) {
            let alimento = criar({ ...result.value, user: this.user });
            return salvar(alimento);
          }
        });
      };

      this.$store.commit("setTravaBack", false);
      if (
        this.alimentoAberto &&
        ![null, undefined, ""].includes(this.alimentoAberto.id)
      ) {
        // pode editar ou criar suplemento!
        let resAtualizar = window.confirm(
          this.strings[this.idioma].suplemento_deseja_atualizar
        );
        if (resAtualizar) {
          let alimentoParam = {
            id: this.alimentoAberto.id,
            id_dieta: this.alimentoAberto.id_dieta,
            nome: this.alimentoAberto.nome,
            id_tipo: this.alimentoAberto.id_tipo,
            atualizar: 1,
            user: this.user,
          };
          let alimento = criar(alimentoParam);
          return salvar(alimento);
        }
      }
      return prompt((result) => {
        if (result.isConfirmed && result.value !== null) {
          let alimento = criar({ ...result.value, user: this.user });
          return salvar(alimento);
        }
      });
    },
    setQuantidade() {
      if (this.temDadosFaltantesUser(this.user)) return;
      if (!this.getAcessoModulo({ user: this.user, modulo: CRIAR_SUPLEMENTO }))
        return;

      const prompt = (callback = null) => {
        let htmlSwal = `
			  <h4>${
          this.strings[this.idioma].quantidade_produzida
        }:</h4><input style="border:1px solid #000; padding: 5px; width: 100px; text" type="number" id="quantidade"/>
	        `;
        return Swal.fire({
          width: "300px",
          html: htmlSwal,
          confirmButtonText: this.strings[this.idioma].salvar,
          preConfirm: () => {
            this.$store.state.app.animal.total_racao_a_produzir.valor =
              document.getElementById("quantidade").value;
            this.$store.state.app.animal.total_racao_a_produzir.valor_raw =
              parseFloat(document.getElementById("quantidade").value);
            this.quantidade_produzida = parseFloat(
              document.getElementById("quantidade").value
            );
            return true;
          },
        });
      };

      return prompt((result) => {
        if (result.isConfirmed && result.value !== null) {
        }
      });
    },

    calcPB() {
      return this.alimentos_selecionados
        .map(
          (a) =>
            100 *
            ((this.parseString(a.quantidade, this.idioma) / 100) *
              (a.nutrientes["MS"] / 100) *
              (a.nutrientes["PB"] / 100))
        )
        .reduce((a, b) => a + b, 0)
        .toFixed(2)
        .replace(".", this.strings[this.idioma].separador_float);
    },
    validatePerc() {
      let minimo = this.alimentos_selecionados
        .map((a) => 100 * (this.parseString(a.minimo, this.idioma) / 100))
        .reduce((a, b) => a + b, 0);
      let maximo = this.alimentos_selecionados
        .map((a) => 100 * (this.parseString(a.maximo, this.idioma) / 100))
        .reduce((a, b) => a + b, 0);
      let quantidade = this.alimentos_selecionados
        .map((a) => 100 * (this.parseString(a.quantidade, this.idioma) / 100))
        .reduce((a, b) => a + b, 0);
      let dados = { minimo, maximo, quantidade };
      for (let prop in dados) {
        if (["minimo", "maximo"].includes(prop)) continue;
        if (dados[prop] > 100) {
          let resto = dados[prop] - 100;
          let retirar =
            resto / Object.values(this.alimentos_selecionados).length;
          let retirado = 0;
          while (retirado < resto) {
            for (let a of Object.values(this.alimentos_selecionados)) {
              let qtd = parseFloat(
                a[prop].replace(this.strings[this.idioma].separador_float, ".")
              );
              if (qtd === null || isNaN(qtd) || qtd === 0) continue;
              if (qtd < retirar) {
                retirado += qtd;
                a[prop] = (
                  parseFloat(
                    a[prop].replace(
                      this.strings[this.idioma].separador_float,
                      "."
                    )
                  ) - qtd
                )
                  .toFixed(2)
                  .replace(".", this.strings[this.idioma].separador_float);
              } else {
                retirado += retirar;
                a[prop] = (
                  parseFloat(
                    a[prop].replace(
                      this.strings[this.idioma].separador_float,
                      "."
                    )
                  ) - retirar
                )
                  .toFixed(2)
                  .replace(".", this.strings[this.idioma].separador_float);
              }
            }
          }
        }
      }
    },
    calcPerc(type = "display") {
      this.atualizarMSTotalAlimentosSelecionados();
      if (this.tipoEntrada === "/%MN") {
        let perc = this.alimentos_selecionados
          .map((a) => 100 * (this.parseString(a.quantidade, this.idioma) / 100))
          .reduce((a, b) => a + b, 0);
        if (type === "validate") this.validatePerc();
        perc = Number(perc.toFixed(3));
        return ["display", "validate"].includes(type)
          ? perc
              .toFixed(2)
              .replace(".", this.strings[this.idioma].separador_float)
          : perc;
      } else {
        let perc = 0;
        this.alimentos_selecionados.forEach((element) => {
          if (element.quantidade) {
            let quantidade = element.quantidade.replace(",", ".");
            perc += parseFloat(quantidade);
          }
        });
        perc = Number(perc.toFixed(3));
        if (perc === parseFloat(this.quantidade_produzida)) return 100;
      }
    },
    atualizarMSTotalAlimentosSelecionados() {
      var quantidadeMS = 0;
      this.alimentos_selecionados.forEach((element) => {
        if (element.quantidade) {
          let quantMN = parseFloat(element.quantidade.replace(",", "."));
          let MSAlimento = element.nutrientes.MS / 100;
          if (this.tipoEntrada !== "/%MN") {
            quantMN =
              (parseFloat(element.quantidade.replace(",", ".")) /
                this.quantidade_produzida) *
              100;
          }
          quantidadeMS += quantMN * MSAlimento;
        }
      });
      this.MSTotalAlimentos = quantidadeMS;
    },
    onlyFloat(val, input, tipo, idioma = 1) {
      if (input.quantidade)
        input.quantidade = input.quantidade.replace(
          this.idioma === 0 || this.idioma === 2 ? "." : ",",
          this.strings[this.idioma].separador_float
        );

      if (input.custo)
        input.custo = input.custo.replace(
          this.idioma === 0 || this.idioma === 2 ? "." : ",",
          this.strings[this.idioma].separador_float
        );

      if (!tipo) this.$onlyFloat(val, this, input, idioma);
      else this.$onlyFloat(val, input, tipo, idioma);
    },
    sejaPremium() {
      this.$store.commit("openOKModal", {
        title: "",
        msg: this.strings[this.idioma].funcionalidade_exclusiva_premium,
      });
    },
    getAditivos() {
      this.axios.post("aditivos/getAditivos").then((r) => {
        this.aditivos = r.data.data;
        let ing = this.aditivos.map((a) => {
          let res = {};
          res["id"] = "AD|" + a.id;
          res["exigencia"] = a.nome;
          res["exigencia_en"] = a.nome_ingles;
          res["exigencia_es"] = a.nome_espanhol;
          res["unidade"] = a.unidade;
          res["unidade_en"] = a.unidade;
          res["unidade_es"] = a.unidade;
          return res;
        });
        this.ingredientesComAditivos = [
          ...Object.values(this.ingredientesCompletos),
          ...ing,
        ];
      });
    },
    loadAlimentosDieta() {
      this.loadingAlimentos = true;
      this.loadingStep1 = true;
      getAlimentos(this.$store, this.axios, false, -1).then((r) => {
        this.loadingAlimentos = false;
        this.loadingStep1 = false;
        this.queryWork();
      });
    },
    verEmpresa(al) {
      const verDados = async (telefone) => {
        let empresa = al.empresa;
        let resEmpTec = await this.axios.post(
          "empresa/getEmpTecnicoMaisProximo",
          { id_empresa: empresa.id }
        );
        let empTec = resEmpTec.data.data;
        // --------------------------------------------------
        let res = "";
        res += this.strings[this.idioma].nome + ": " + al.empresa.nome + "<br>";
        res +=
          this.strings[this.idioma].email +
          ": " +
          '<a href="mailto:' +
          al.empresa.email +
          '">' +
          al.empresa.email +
          "</a><br>";

        res +=
          this.strings[this.idioma].cnpj +
          ":" +
          this.$formatCnpjCpf(String(al.empresa.cnpj)) +
          "<br>";
        res +=
          this.strings[this.idioma].telefone +
          ": +" +
          telefone.cod_pais +
          "(" +
          telefone.DDD +
          ")" +
          telefone.telefone +
          "<br>";
        if (al.empresa.site !== null) {
          res +=
            this.strings[this.idioma].site +
            ": " +
            '<a href="' +
            al.empresa.site +
            '">' +
            al.empresa.site +
            "</a><br>";
        }
        if (empTec !== null) {
          res += "------------------------------------------<br>";
          res +=
            "<h4>" +
            this.strings[this.idioma].tecnico_mais_proximo +
            ":</h4> <br>";
          res += this.strings[this.idioma].nome + ": " + empTec.nome + "<br>";
          res +=
            this.strings[this.idioma].email +
            ": " +
            '<a href="mailto:' +
            empTec.email +
            '">' +
            empTec.email +
            "</a><br>";
          res +=
            this.strings[this.idioma].telefone +
            ": +" +
            empTec.cod_pais +
            "(" +
            empTec.DDD +
            ")" +
            empTec.telefone +
            "<br>";
          res += empTec.descricao + "<br>";
        }
        let msg = res;
        let title = al.name;
        this.$store.commit("openOKModal", {
          title,
          msg,
        });
        this.info = false;
      };
      this.axios
        .post("empresa/getTelefone", { id: al.empresa.id_telefone })
        .then((res) => {
          verDados(res.data.data);
        });
    },
    getAlimentosExtras() {
      this.axios
        .post("alimentos/getAlimentosUsuario", { id_pessoa: this.user.id })
        .then((res) => {
          let meusAlimentos = [];
          for (let al of res.data.data) {
            let alim = Object.assign({}, al);
            alim["nutrientes"] = JSON.parse(al.nutrientes);
            meusAlimentos.push(alim);
          }
          this.$store.commit("setAlimentosUsuario", {
            alimentos: meusAlimentos,
          });
        });
      if (this.empresa === null || !this.empresa[0].id) {
        this.axios
          .post(
            this.user.permissao === 0
              ? "alimentos/getAlimentos"
              : "alimentos/getAlimentosPatrocinados",
            {}
          )
          .then((res) => {
            let meusAlimentos = [];
            for (let al of res.data.data) {
              let alim = Object.assign({}, al);
              alim["nutrientes"] = JSON.parse(al.nutrientes);
              meusAlimentos.push(alim);
            }
            this.$store.commit("setAlimentosEmpresa", {
              alimentos: meusAlimentos,
            });
          });
      } else {
        this.axios
          .post(
            this.user.permissao === 0
              ? "alimentos/getAlimentos"
              : "alimentos/getAlimentosEmpresa",
            { id_empresa: this.empresa[0].id }
          )
          .then((res) => {
            let meusAlimentos = [];
            for (let al of res.data.data) {
              let alim = Object.assign({}, al);
              alim["nutrientes"] = JSON.parse(al.nutrientes);
              meusAlimentos.push(alim);
            }
            this.$store.commit("setAlimentosEmpresa", {
              alimentos: meusAlimentos,
            });
          });
      }
    },
    queryWork() {
      if (this.$route.query.alid) {
        if (
          createMD5(String(this.$route.query.alid)) ===
            this.$route.query.assinatura ||
          this.user.permissao === 0
        ) {
          this.axios
            .post("alimentos/getAlimento", {
              id: "USR|" + this.$route.query.alid,
            })
            .then((r) => {
              this.alimentoAberto = { ...r.data.data };
              let ingrediente = JSON.parse(r.data.data.ingredientes);
              let alsel = [];
              for (let cat of this.$store.state.app.categorias_alimentos) {
                for (let alimento of cat.derivados) {
                  if (!Object.keys(ingrediente).includes(alimento.id)) continue;
                  alimento.quantidade = parseFloat(ingrediente[alimento.id])
                    .toFixed(2)
                    .replace(".", this.strings[this.idioma].separador_float);
                  alimento.quantidade_raw = parseFloat(
                    ingrediente[alimento.id]
                  );
                  alsel.push(alimento);
                }
              }
              this.$store.commit("setAlimentosSelecionados", alsel);
              this.treeAlimentos = alsel;
            });
        } else {
          this.alimentoAberto = {};
        }
      }
      if (this.$route.query.tabela) {
        try {
          JSON.parse(atob(this.$route.query.tabela));
          localStorage.setItem("tabela", atob(this.$route.query.tabela));
        } catch (e) {
          window.location.href = "/tabela-resumida";
        }
      }
    },
    salvaTabela() {
      let name = window.prompt(
        this.strings[this.idioma].digite_nome_salvar + ":"
      );
      if (name) {
        this.$store.commit("saveTabela", name);
        updateData(this.$store.state, this.axios);
      }
    },
    async exporta() {
      if (
        !this.getAcessoModulo({
          user: this.user,
          modulo: EXPORTAR_PDF_COMPLETO,
        })
      )
        return this.sejaPremium();
      if (this.temDadosFaltantesUser(this.user)) return;
      await this.criarSuplemento();
      this.$store.commit("setExportando", true);
      this.alimentos_selecionados.forEach((al) => {
        let alimento = al;
        for (let i in al.nutrientes) {
          if (
            (isNaN(alimento.nutrientes[i]) ||
              isNaN(this.parseString(al.nutrientes[i], this.idioma))) &&
            al.nutrientes[i][al.nutrientes[i].length - 4] === "."
          ) {
            alimento.nutrientes[i] = parseFloat(alimento.nutrientes[i]);
          } else {
            alimento.nutrientes[i] = this.parseString(
              al.nutrientes[i],
              this.idioma
            ).toFixed(2);
          }
        }
      });
      let cliente = localStorage.getItem("cliente");
      let clienteID = null;
      if (cliente !== null) {
        cliente = JSON.parse(cliente);
        clienteID = cliente.id;
      }
      let idsAlimentos =
        this.alimentoAberto && this.alimentoAberto.id
          ? [
              "USR|" + this.alimentoAberto.id,
              ...Object.values(this.alimentos_selecionados).map((a) => a.id),
            ]
          : [...Object.values(this.alimentos_selecionados).map((a) => a.id)];
      /* this.$store.dispatch('relatorioTabelaResumida', { alimentos: this.alimentos_selecionados }).then(r => {
	        console.log({ r })
	      }) */
      // this.axios.post('relatorios/tabelaResumida', { idioma: this.idioma, ingredientes: this.ingredientes, tipos: this.categorias_alimentos, alimentos_selecionados: this.alimentos_selecionados, alimentos: this.alimentos_selecionados.slice(0, 40), idCliente: clienteID }).then(res => {
      this.axios
        .post("relatorios/tabelaResumida", {
          idioma: this.idioma,
          idsAlimentos: idsAlimentos,
          idCliente: clienteID,
        })
        .then((res) => {
          var link = document.createElement("a");
          link.href = res.data.pdf;
          link.target = "_blank";
          let win = window.open(link.href, link.target);
          if (!win || win === null) {
            link.click();
            let msg = link.href;
            let title = "Download Link";
            this.$copyText(msg);
            msg =
              '<textarea readonly style="width: 100%; height: 200px;" value="' +
              msg +
              '">' +
              msg +
              "</textarea>";
            this.$store.commit("openOKModal", { title, msg });
          }

          this.$store.commit("getDefaultExportando");
        })
        .catch((err) => {
          let msg = this.strings[this.idioma].problema_relatorio;
          let time = 6000;
          this.$store.commit("openErrorAlert", { msg, time });
          this.$store.commit("getDefaultExportando");
          console.error(err);
        });
    },

    async exportaCompleto(tipo = "pdf") {
      const exportaDados = (alimento) => {
        this.$store.commit("setExportando", true);
        this.$store.commit("getDefaultComposicaoRacao");
        this.$store.dispatch("calculaPredicao", { onlyReturn: true });
        this.composicao_racao["proporcaoVC"]["unidade"] =
          this.composicao_racao["proporcaoVC"]["v"] +
          ":" +
          Math.abs(this.composicao_racao["proporcaoVC"]["v"] - 100);
        this.composicao_racao["proporcaoVC"]["c"] = Math.abs(
          this.composicao_racao["proporcaoVC"]["v"] - 100
        );

        let cliente = localStorage.getItem("cliente");
        let clienteID = null;
        if (cliente !== null) {
          cliente = JSON.parse(cliente);
          clienteID = cliente.id;
        }

        let idsAlimentos =
          this.alimentoAberto && this.alimentoAberto.id
            ? [
                "USR|" + this.alimentoAberto.id,
                ...Object.values(this.alimentos_selecionados).map((a) => a.id),
              ]
            : [...Object.values(this.alimentos_selecionados).map((a) => a.id)];

        let post_pdf_completo = {
          idioma: this.idioma,
          animal: this.animal,
          exigencias: this.exigencias,
          alimentos_selecionados: this.alimentos_selecionados,
          alimentos: this.alimentos_selecionados,
          dieta: this.composicao_dieta,
          racao: this.composicao_racao,
          excrecao: this.excrecao,
          predicao: this.dados_predicao,
          idDieta: this.dieta_salva ? this.dieta_salva.id : null,
          idCliente: clienteID,
          idsAlimentos: idsAlimentos,
          volumoso: this.composicao_racao["proporcaoVC"]["v"],
          eficiencia: this.composicao_racao["eficienciaAlimentar"]["total"],
          simples: tipo === "spdf",
          relatorio_campo: tipo === "campo_pdf",
          mixNaoSalvo: this.alimentoAberto.id > 0 ? false : alimento,
        };

        let totalCusto = 0;
        if (this.tipoEntrada === "/%MN") {
          this.alimentos_selecionados.forEach((alimento) => {
            if (
              alimento.quantidade &&
              alimento.custo &&
              parseFloat(alimento.quantidade.replace(",", ".")) > 0 &&
              parseFloat(alimento.custo.replace(",", ".")) > 0
            ) {
              var quantidade =
                (this.quantidade_produzida *
                  parseFloat(alimento.quantidade.replace(",", "."))) /
                100;
              let custo = (
                parseFloat(quantidade) *
                parseFloat(alimento.custo.replace(",", "."))
              ).toFixed(3);
              this.composicao_racao["CUSTO"]["alimentos"][alimento.id][
                "valor"
              ] = parseFloat(custo);
              this.composicao_racao["CUSTO"]["alimentos"][alimento.id][
                "valorUnidade"
              ] = parseFloat(custo);
              totalCusto += parseFloat(custo);
            }
          });
        } else {
          this.alimentos_selecionados.forEach((alimento) => {
            if (alimento.quantidade && alimento.custo) {
              let custo = (
                parseFloat(alimento.custo.replace(",", ".")) *
                parseFloat(alimento.quantidade.replace(",", "."))
              ).toFixed(3);
              this.composicao_racao["CUSTO"]["alimentos"][alimento.id][
                "valor"
              ] = parseFloat(custo);
              this.composicao_racao["CUSTO"]["alimentos"][alimento.id][
                "valorUnidade"
              ] = parseFloat(custo);
              totalCusto += parseFloat(custo);
            }
          });
          //Atualizacação dos nutrientes
          this.ingredientesComAditivos.forEach((ing) => {
            let ingredienteId = ing["id"].replace(" ", "");
            alimento["nutrientes"][ingredienteId] = parseFloat(
              this.alimentos_selecionados
                .map((a) => {
                  let val = 0;
                  if (a.quantidade) {
                    val =
                      (((parseFloat(a.quantidade.replace(",", ".")) /
                        this.quantidade_produzida) *
                        this.parseString(a.nutrientes["MS"])) /
                        this.MSTotalAlimentos) *
                      this.parseString(a.nutrientes[ingredienteId]);

                    if (ingredienteId === "MS") {
                      val =
                        (parseFloat(a.quantidade.replace(",", ".")) /
                          this.quantidade_produzida) *
                        this.parseString(a.nutrientes["MS"]);
                    }
                  }

                  return val >= 0 ? val : 0;
                })
                .reduce((a, b) => a + b, 0)
                .toFixed(2)
            );
          });
        }

        this.composicao_racao["CUSTO"]["total"] = totalCusto;

        if (true) {
          this.axios
            .post("relatorios/formulacaoAlimento", {
              idioma: this.idioma,
              animal: this.animal,
              exigencias: this.exigencias,
              alimentos_selecionados: this.alimentos_selecionados,
              alimentos: this.alimentos_selecionados,
              dieta: this.composicao_dieta,
              racao: this.composicao_racao,
              excrecao: this.excrecao,
              predicao: this.dados_predicao,
              idDieta: this.dieta_salva ? this.dieta_salva.id : null,
              idCliente: clienteID,
              idsAlimentos: idsAlimentos,
              volumoso: this.composicao_racao["proporcaoVC"]["v"],
              eficiencia: this.composicao_racao["eficienciaAlimentar"]["total"],
              simples: tipo === "spdf",
              relatorio_campo: tipo === "campo_pdf",
              mixNaoSalvo: this.alimentoAberto.id > 0 ? false : alimento,
            })
            .then((res) => {
              let link = document.createElement("a");
              link.href = res.data.pdf;
              link.target = "_blank";
              let win = window.open(link.href, link.target);
              if (!win || win === null) {
                link.click();
                let msg = link.href;
                let title = "Download Link";
                this.$copyText(msg);
                msg =
                  '<textarea readonly style="width: 100%; height: 200px;" value="' +
                  msg +
                  '">' +
                  msg +
                  "</textarea>";
                this.$store.commit("openOKModal", { title, msg });
              }
              this.$store.commit("getDefaultExportando");
            })
            .catch((err) => {
              let msg = this.strings[this.idioma].problema_relatorio;
              let time = 6000;
              this.$store.commit("openErrorAlert", { msg, time });
              this.$store.commit("getDefaultExportando");
              console.error(err);
            });
        }
      };
      const criar = ({
        nome = "",
        nome_sci = "",
        tipo = null,
        id_tipo = null,
        nutrientes = {},
        user = null,
        id = null,
        atualizar = 0,
      }) => {
        let alimento = {
          nome: nome,
          nome_sci: nome_sci,
          tipo: tipo,
          id_tipo: id_tipo,
          nutrientes: nutrientes,
          user: user,
          id_pessoa: user !== null ? user.id : null,
          id: id,
          atualizar: atualizar,
        };
        nutrientes = {};
        let ingredientesSupl = {};
        for (let alimento of this.alimentos_selecionados) {
          if (alimento.quantidade === null || alimento.quantidade === "")
            continue;
          ingredientesSupl[alimento.id] = parseFloat(
            alimento.quantidade.replace(
              this.strings[this.idioma].separador_float,
              "."
            )
          );
          if (
            ingredientesSupl[alimento.id] === 0 ||
            isNaN(ingredientesSupl[alimento.id])
          )
            delete ingredientesSupl[alimento.id];
        }
        let alimentosIDs = this.alimentos_selecionados.map((a) => a.id);
        alimento["ingredientes"] = ingredientesSupl;
        alimento["id_dieta"] = null;
        let alimentosSelecionados = Object.values(
          this.alimentos_selecionados
        ).filter((al) => alimentosIDs.includes(al.id));
        this.aditivos.forEach((aditivo) => {
          let item = aditivo.id;
          nutrientes["AD|" + item] = alimentosSelecionados
            .map((al) => {
              let nut = !isNaN(al.nutrientes["AD|" + item])
                ? al.nutrientes["AD|" + item]
                : al.nutrientes[String("AD|" + item).toUpperCase()];
              let nutMS = al.nutrientes["MS"];

              if (nut === undefined) {
                nut = 0;
              } else {
                nut = parseFloat(String(nut).replace(",", "."));
              }

              let cont =
                nut *
                ((ingredientesSupl[al.id] * nutMS) / this.MSTotalAlimentos);
              return ingredientesSupl[al.id] ? cont / 100 : 0;
            })
            .reduce((a, b) => a + b, 0);
        });

        Object.keys(this.ingredientesCompletos).forEach((item) => {
          nutrientes[item] = parseFloat(
            alimentosSelecionados
              .map((al) => {
                let nut = al.nutrientes[String(item).toUpperCase()];
                let nutMS = al.nutrientes["MS"];

                switch (item) {
                  case "NDT":
                    if (nut === undefined || nut === "0.00" || nut === 0) {
                      nut = al.nutrientes["NDT_BRCORTE2016"];
                    }
                    break;
                }
                let cont =
                  nut *
                  ((ingredientesSupl[al.id] * nutMS) / this.MSTotalAlimentos);
                if (item === "MS") {
                  cont = nut * ingredientesSupl[al.id];
                }
                return ingredientesSupl[al.id] ? cont / 100 : 0;
              })
              .reduce((a, b) => a + b, 0)
              .toFixed(2)
          );

          nutrientes[String(item).toUpperCase()] = nutrientes[item];
          switch (item) {
            case "NDT":
              nutrientes["NDT_BRCORTE2016"] = nutrientes["NDT_OBS"] =
                nutrientes[item];
              break;
          }
        });
        alimento.nutrientes = nutrientes;
        return alimento;
      };
      if (
        this.quantidade_produzida === null ||
        !this.quantidade_produzida > 0
      ) {
        this.setQuantidade();
        return false;
      }
      let alimento = [];
      if (this.alimentoAberto.id > 0 ? false : true) {
        alimento = criar({ user: this.user });
      } else {
        alimento = this.alimentoAberto;
        if (this.isJSON(this.alimentoAberto.nutrientes))
          alimento.nutrientes = JSON.parse(this.alimentoAberto.nutrientes);
      }
      exportaDados(alimento);
    },

    isJSON(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },

    checkMineraisComuns() {
      const padroes = FONTES_COMUNS;
      let indexCat = 8;
      indexCat = this.categorias_alimentos.findIndex((al) => {
        return al.id === indexCat;
      });
      let status = this.getSelecionaComunsStatus;
      padroes.forEach((idAl) => {
        let index = this.treeAlimentos.findIndex((el) => el.id === idAl);
        if (!status && index === -1) {
          let indexAlimento = this.categorias_alimentos[
            indexCat
          ].derivados.findIndex((el) => el.id === idAl);
          this.alimentos_selecionados.push(
            this.categorias_alimentos[indexCat].derivados[indexAlimento]
          );
        } else if (status && index > -1) {
          this.removeAlimento(index);
        }
      });
      this.$store.commit(
        "setAlimentosSelecionados",
        this.alimentos_selecionados
      );
      this.treeAlimentos = this.alimentos_selecionados;
    },

    volumosoController() {
      var vc = this.$store.state.app.vc;
      if (vc.v >= 100) {
        vc.c = 1;
      } else if (vc.v <= 0) {
        vc.c = 99;
      } else {
        vc.c = 100 - vc.v;
      }
      vc.v = 100 - vc.c;
    },
    concentradoController() {
      var vc = this.$store.state.app.vc;
      if (vc.c >= 100) {
        vc.v = 1;
      } else if (vc.c <= 0) {
        vc.v = 99;
      } else {
        vc.v = 100 - vc.c;
      }
      vc.c = 100 - vc.v;
    },
    etapa5() {
      this.calculandoDieta = true;
      this.dietaOtimizada = false;
      this.dietaSemiOtima = false;
      this.stepComplete[3] = true;
      this.$store.commit("getDefaultComposicaoRacao");
      this.$store.commit("getDefaultComposicaoDieta");
      this.$store.dispatch("calcularDieta").then((response) => {
        let dados = { data_simplex: JSON.stringify(response) };
        this.axios
          .post("brcorte/simplex", { dados })
          .then((response) => {
            // implementar ainda para status 2
            if (response.data.status < 200) {
              this.dietaOtimizada = false;
              this.calculandoDieta = false;
            } else {
              this.$store
                .dispatch("processaResultadoDieta", response.data.data)
                .then((response) => {
                  if (response.status) this.dietaOtimizada = true;
                  this.calculandoDieta = false;
                  if (response.dieta.status === 2) {
                    this.dietaSemiOtima = true;
                  }
                  this.$nextTick(() => {
                    // expansão do MS
                    if (this.$refs && this.$refs.dTableComposicaoRacao) {
                      this.$set(
                        this.$refs.dTableComposicaoRacao.expanded,
                        "ms",
                        true
                      );
                      if (
                        this.animal.tipo.valor === this.CRESCIMENTO_TERMINACAO
                      ) {
                        this.headersRelatorioFinanceiro.forEach((el) => {
                          this.$set(
                            this.$refs.dTableRelatorioFinanceiro.expanded,
                            el.id,
                            true
                          );
                        });
                      }
                    }
                  });
                });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    recalculaDietaVC(vc) {
      this.etapa5();
    },
    calculo1(animal) {
      this.stepComplete[0] = false;
      if (this.idioma === 0 || this.idioma === 2) {
        animal["peso_corporal_medio"].valor = (
          (parseFloat(
            animal["peso_corporal_inicial"].valor
              .replace(/[.]/g, "")
              .replace(/[,]/g, ".")
          ) +
            parseFloat(
              animal["peso_corporal_final"].valor
                .replace(/[.]/g, "")
                .replace(/[,]/g, ".")
            )) /
          2.0
        ).toFixed(2);
        animal["peso_corporal_medio"].valor = animal[
          "peso_corporal_medio"
        ].valor.replace(/[.]/g, ",");
        animal["custo_total"].valor = animal["custo_mao_de_obra"].valor
          ? (
              parseFloat(
                animal["custo_mao_de_obra"].valor
                  .replace("R$", "")
                  .replace(/[.]/g, "")
                  .replace(/[,]/g, ".")
              ) +
              parseFloat(
                animal["custo_energia"].valor
                  .replace("R$", "")
                  .replace(/[.]/g, "")
                  .replace(/[,]/g, ".")
              ) +
              parseFloat(
                animal["custo_maquinario"].valor
                  .replace("R$", "")
                  .replace(/[.]/g, "")
                  .replace(/[,]/g, ".")
              ) +
              parseFloat(
                animal["custo_medicamentos"].valor
                  .replace("R$", "")
                  .replace(/[.]/g, "")
                  .replace(/[,]/g, ".")
              ) +
              parseFloat(
                animal["custo_extra"].valor
                  .replace("R$", "")
                  .replace(/[.]/g, "")
                  .replace(/[,]/g, ".")
              )
            ).toFixed(2)
          : null;
        animal["custo_total"].valor = animal["custo_total"].valor
          ? "R$" + animal["custo_total"].valor.replace(/[.]/g, ",")
          : null;
      } else {
        animal["peso_corporal_medio"].valor = (
          (parseFloat(
            animal["peso_corporal_inicial"].valor.replace(/[,]/g, "")
          ) +
            parseFloat(
              animal["peso_corporal_final"].valor.replace(/[,]/g, "")
            )) /
          2.0
        ).toFixed(2);
        animal["custo_total"].valor = animal["custo_mao_de_obra"].valor
          ? (
              parseFloat(
                animal["custo_mao_de_obra"].valor
                  .replace("U$", "")
                  .replace(/[,]/g, "")
              ) +
              parseFloat(
                animal["custo_energia"].valor
                  .replace("U$", "")
                  .replace(/[,]/g, "")
              ) +
              parseFloat(
                animal["custo_maquinario"].valor
                  .replace("U$", "")
                  .replace(/[,]/g, "")
              ) +
              parseFloat(
                animal["custo_medicamentos"].valor
                  .replace("U$", "")
                  .replace(/[,]/g, "")
              ) +
              parseFloat(
                animal["custo_extra"].valor
                  .replace("U$", "")
                  .replace(/[,]/g, "")
              )
            ).toFixed(2)
          : null;
        animal["custo_total"].valor = animal["custo_total"].valor
          ? "U$" + animal["custo_total"].valor
          : null;
      }
    },
    calculosPasso1() {
      if (this.$refs.formAnimal.validate()) {
        this.step = 2;
        this.loadingStep2 = true;
        this.$nextTick(() => {
          setTimeout(() => {
            this.$store.commit("setLeiteDeVaca");
            this.$store.dispatch("calculaExigencias").then(() => {
              this.stepComplete[0] = true;
              this.loadingStep2 = false;
            });
          }, 1000);
        });
      }
    },
    changeMinMaxExigencias(name) {
      this.changeMinMax = true;
      this.$store.commit("setMinMaxExigencias", name);
      this.$nextTick(() => {
        this.changeMinMax = false;
      });
    },
    changeMinExigencias(name) {
      this.changeMinMax = true;
      this.$store.commit("setMinExigencias", name);
      this.$nextTick(() => {
        this.changeMinMax = false;
      });
    },
    changeMaxExigencias(name) {
      this.changeMinMax = true;
      this.$store.commit("setMaxExigencias", name);
      this.$nextTick(() => {
        this.changeMinMax = false;
      });
    },
    changeSelectExigencia(exigencia, exigencias, selecionadas, name) {
      if (!exigencia.radio) {
        exigencia.selecionado = !exigencia.selecionado;
        if (exigencia.selecionado) {
          selecionadas.add(name);
          if (selecionadas.size === 20) {
            this.selected = true;
            this.indetermined = false;
          } else {
            this.indetermined = true;
            this.selected = false;
          }
        } else {
          selecionadas.delete(name);
          if (selecionadas.size === 1) {
            this.selected = false;
            this.indetermined = false;
          } else {
            this.indetermined = true;
            this.selected = false;
          }
        }
      } else {
        exigencia.selecionado = true;
        exigencia.otherOptions.forEach((el) => {
          exigencias[el].selecionado = false;
          selecionadas.delete(el);
        });
        selecionadas.add(name);
        if (selecionadas.size === 20) {
          this.selected = true;
          this.indetermined = false;
        } else {
          this.indetermined = true;
          this.selected = false;
        }
      }
      this.$nextTick(() => {
        this.stepComplete[0] = selecionadas.size >= 2;
      });
    },
    displayCondicional(input, animal) {
      if (!input.depende) return null;
      for (var i = 0; i < input.depende.length; i++) {
        if (
          input.valorDepende[i].includes(animal[input.depende[i]].valor) &&
          this.renderCondicional(animal[input.depende[i]], animal)
        )
          return null;
      }
      return "display: none";
    },
    displayRadioCondicional(input, option, animal) {
      if (!option.depende) return null;
      if (
        (option.valorDepende.includes(animal[option.depende].valor) ||
          !animal[option.depende].valor) &&
        this.renderCondicional(animal[option.depende], animal)
      )
        return null;
      if (input.valor === option.valor) input.valor = null;
      return "display: none";
    },
    parseString(valor, idioma) {
      return this.$parseString(valor, idioma);
    },
    removeAlimento(index) {
      // adaptação para tabela resumida;
      this.alimentos_selecionados.splice(index, 1);
      // ------------------------------
      // this.treeAlimentos.splice(index, 1)
    },
    renderCondicional(input, animal) {
      if (!input.depende) return true;
      for (var i = 0; i < input.depende.length; i++) {
        if (
          input.valorDepende[i].includes(animal[input.depende[i]].valor) &&
          this.renderCondicional(animal[input.depende[i]], animal)
        )
          return true;
      }
      return false;
    },
    renderEstadoFisiologico(animal, estado, index, idioma) {
      if (index === 0) {
        return estado.options[index].title[idioma];
      } else if (index === 1) {
        let text = estado.options[index].title[idioma];
        if (idioma === 0)
          text += " | " + animal.producao_de_leite.valor + " kg/dia";
        else if (idioma === 2)
          text += " | " + animal.producao_de_leite.valor + " kg/día";
        else text += " | " + animal.producao_de_leite.valor + " kg/day";
        text +=
          " | " +
          animal.semana_lactacao.valor +
          " | " +
          animal.proteina_do_leite.valor +
          " | " +
          animal.gordura_do_leite.valor +
          " | " +
          animal.lactose_do_leite.valor;
        return text;
      } else if (index === 2) {
        let text = estado.options[index].title[idioma];
        text +=
          " | " +
          animal.escore_corporal.valor +
          " | " +
          animal.peso_bezerro_nascimento.valor +
          " | " +
          animal.dias_gestacao.valor;
        return text;
      } else {
        let text = estado.options[index].title[idioma];
        if (idioma === 0)
          text += " | " + animal.producao_de_leite.valor + " kg/dia";
        else if (idioma === 2)
          text += " | " + animal.producao_de_leite.valor + " kg/día";
        else text += " | " + animal.producao_de_leite.valor + " kg/day";
        text +=
          " | " +
          animal.semana_lactacao.valor +
          " | " +
          animal.proteina_do_leite.valor +
          " | " +
          animal.gordura_do_leite.valor +
          " | " +
          animal.lactose_do_leite.valor;
        text +=
          " | " +
          animal.escore_corporal.valor +
          " | " +
          animal.peso_bezerro_nascimento.valor +
          " | " +
          animal.dias_gestacao.valor;
        return text;
      }
    },
    resetAlimentos() {
      this.alimentos_selecionados.forEach((al) => {
        al.quantidade = null;
        al.custo = null;
        al.minimo = null;
        al.maximo = null;
      });
    },
    resetDieta() {
      this.$store.commit("getDefaultAnimal");
      this.$store.commit("getDefaultExigencias");
      this.$store.commit("getDefaultAlimentos");
      this.search = null;
      this.treeAlimentos = [];
      this.open = [];
      this.selected = false;
      this.indetermined = false;
      this.step = 1;
      this.stepComplete = [false, false, false, false, false];
    },
    changeRadioAnimal(input, animal) {
      let val = input.valor;
      if (val === CRESCIMENTO_TERMINACAO || val === VACA || val === BEZERRO) {
        this.$nextTick(() => {
          this.$refs.formAnimal.validate();
        });
      }
    },
    renderInputTotal(total, min, max) {
      min = this.parseString(min, this.idioma);
      max = this.parseString(max, this.idioma);
      if (total >= min && total <= max)
        return "text-field-table input-disabled total-verde";
      else if (total < min)
        return "text-field-table input-disabled total-amarelo";
      else return "text-field-table input-disabled total-vermelho";
    },
    renderMask(esq, dir, idioma) {
      return {
        decimal: !idioma ? "," : ".",
        thousands: !idioma ? "." : ",",
        precision: 2,
        prefix: esq[idioma] + " ",
        suffix: " " + dir[idioma],
      };
    },
    resetNutrientes(index) {
      this.calculandoNutrientes = true;
      this.$store.dispatch("recalculaNutrientes", index).then(() => {
        this.calculandoNutrientes = false;
      });
    },
    resetExigencias(index) {
      this.recalculandoExigencias = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$store.dispatch("calculaExigencias").then(() => {
            this.recalculandoExigencias = false;
          });
        }, 1000);
      });
    },
    rulesAnimal(input, animal, idioma) {
      var rule = [];
      if (input.required) {
        if ((idioma === 0 || idioma === 2) && input.precisao) {
          if (input.max && input.valor) {
            rule.push(
              (v) =>
                parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
                  input.max ||
                "Valor deve ser menor que " +
                  String(input.max).replace(/[.]/g, ",")
            );
          }
          rule.push(
            (v) => v !== "0,0" || this.strings[this.idioma].obrigatorio
          );
        } else if (idioma === 1 && input.precisao) {
          if (input.max && input.valor) {
            rule.push(
              (v) =>
                parseFloat(v.replace(/[,]/g, "")) <= input.max ||
                "Value must be less than " + String(input.max)
            );
          }
          rule.push(
            (v) => v !== "0.0" || this.strings[this.idioma].obrigatorio
          );
        } else if (!input.precisao) {
          rule.push((v) => v !== "0" || this.strings[this.idioma].obrigatorio);
        }
        if (input.maxPeso && input.valor && idioma === 0) {
          if (animal.tipo.valor === this.BEZERRO) {
            rule.push(
              (v) =>
                parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
                  this.MAX_PESO_BEZERRO ||
                "Valor deve ser menor que " +
                  String(this.MAX_PESO_BEZERRO).replace(/[.]/g, ",")
            );
          } else if (
            animal.tipo.valor === this.VACA ||
            (animal.tipo.valor === this.CRESCIMENTO_TERMINACAO &&
              animal.sexo.valor === this.FEMEA)
          ) {
            rule.push(
              (v) =>
                parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
                  this.MAX_PESO_FEMEA ||
                "Valor deve ser menor que " +
                  String(this.MAX_PESO_FEMEA).replace(/[.]/g, ",")
            );
          } else if (
            animal.tipo.valor === this.CRESCIMENTO_TERMINACAO &&
            (animal.sexo.valor === this.MACHO ||
              animal.sexo.valor === this.MACHO_CASTRADO)
          ) {
            rule.push(
              (v) =>
                parseFloat(v.replace(/[.]/g, "").replace(/[,]/g, ".")) <=
                  this.MAX_PESO_MACHO ||
                "Valor deve ser menor que " +
                  String(this.MAX_PESO_MACHO).replace(/[.]/g, ",")
            );
          }
        }
      }
      return rule;
    },
    textAlignHeader(header, headers) {
      if (this.$vuetify.breakpoint.width >= 991) {
        if (
          header.text !== headers[0][3].text &&
          header.text !== headers[0][4].text &&
          header.text !== headers[0][5].text
        )
          return "text-align: left; font-size: 16px";
        else return "text-align: center; font-size: 16px";
      } else {
        if (
          header.text !== headers[1][1].text &&
          header.text !== headers[1][2].text &&
          header.text !== headers[1][3].text
        )
          return "text-align: left; font-size: 16px";
        else return "text-align: center; font-size: 16px";
      }
    },
    toggleAll(exigencias, selecionadas) {
      if (this.selected || this.indetermined) {
        for (let exigencia in exigencias) {
          if (exigencia !== "CMS") exigencias[exigencia].selecionado = false;
        }
        selecionadas.clear();
        selecionadas.add("CMS");
        this.selected = this.indetermined = false;
      } else {
        for (let exigencia in exigencias) {
          if (!exigencias[exigencia].radio) {
            exigencias[exigencia].selecionado = true;
            selecionadas.add(exigencia);
          } else {
            var notSelected = true;
            exigencias[exigencia].otherOptions.forEach((el) => {
              if (exigencias[el].selecionado) notSelected = false;
            });
            if (notSelected) {
              exigencias[exigencia].selecionado = true;
              selecionadas.add(exigencia);
            }
          }
        }
        this.selected = true;
        this.indetermined = false;
      }
      this.stepComplete[1] = selecionadas.size >= 2;
    },
  },
};
</script>
